/* The Crowd Controller – guided landing page (Ready-to-Go + adaptive builder + analytics hooks).
 * All products, variants, prices and availability come from Shopify product JSON rendered by the sections.
 * Cart: reuses the theme's <cart-provider> ('cart:add' event -> /cart/add.js with multiple items + drawer refresh);
 * falls back to a direct /cart/add.js call when the provider isn't on the page. */
(function () {
  if (window.TCCLanding) return;
  var TCC = (window.TCCLanding = {});

  /* ---------- analytics ---------- */
  /* Tracking (see TRACKING.md in the handoff):
   * - Every event is pushed to window.dataLayer with tcc_source:'tcc_landing'.
   * - add_to_cart / begin_checkout use the GA4 ecommerce schema (currency, value, items[]) and are pushed to the
   *   dataLayer ONLY (never sent with gtag from here). Shopify's own standard events (product_added_to_cart,
   *   checkout_started) already reach GA4/Google Ads through the Google & YouTube app pixel; forwarding these
   *   dataLayer events to the same GA4 property/Ads conversion would double count. Use them in GTM only for a
   *   separate stream/conversion, or keep them as diagnostics.
   * - generate_lead + Ads 'LP Quote Request' conversion fire once on the confirmed quote-form success state
   *   (?contact_posted=true after a valid submit in this tab), never on link clicks (those are request_quote).
   * - purchase is NOT fired here: it comes from Shopify checkout (one pixel source only).
   * - The live storefront has no on-page gtag/GTM (Google tags run in sandboxed Shopify pixels), so gtag() calls below are
   *   no-ops there. Every event is also published as a Shopify custom event 'tcc_<event>' for a custom pixel to forward. */
  var ECOM = { add_to_cart: 1, begin_checkout: 1 };
  TCC.track = function (event, params, opts) {
    params = params || {};
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: event, tcc_page: 'commercial_stanchions', tcc_source: 'tcc_landing' };
      for (var k in params) payload[k] = params[k];
      if (ECOM[event] || params.ecommerce) window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(payload);
      if (typeof window.gtag === 'function' && !ECOM[event]) {
        var gp = {}; for (var g in params) if (g !== 'ecommerce') gp[g] = params[g];
        if (opts && opts.beacon) { gp.transport_type = 'beacon'; if (opts.callback) gp.event_callback = opts.callback; }
        window.gtag('event', event, gp);
      }
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        var pub = {}; for (var pk in params) if (typeof params[pk] !== 'function') pub[pk] = params[pk];
        Shopify.analytics.publish('tcc_' + event, pub);
      }
      document.dispatchEvent(new CustomEvent('tcc:track', { detail: payload }));
    } catch (e) { /* never break the page for analytics */ }
  };
  TCC.currency = function () { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; };
  /* GA4 ecommerce block from setup lines: [{id, quantity, _price (cents), _name, _variant, _sku}] */
  TCC.ecommerce = function (items) {
    var value = 0, list = items.map(function (it) {
      value += (it._price || 0) * it.quantity;
      return { item_id: it._sku || String(it.id), item_name: it._name || '', item_variant: it._variant || '', price: (it._price || 0) / 100, quantity: it.quantity, item_brand: it._vendor || undefined };
    });
    return { currency: TCC.currency(), value: Math.round(value) / 100, items: list };
  };

  /* Ad attribution (gclid / UTMs) captured on landing; passed to checkout as cart attributes. */
  var ATTR_KEYS = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  TCC.attribution = function () {
    var a = {};
    try { a = JSON.parse(sessionStorage.getItem('tcc_attr') || '{}') || {}; } catch (e) {}
    try {
      var q = new URLSearchParams(location.search), got = false;
      ATTR_KEYS.forEach(function (k) { var v = q.get(k); if (v) { a[k] = v.slice(0, 200); got = true; } });
      if (got) { a.landing = 'commercial_stanchions'; sessionStorage.setItem('tcc_attr', JSON.stringify(a)); }
    } catch (e) {}
    return a;
  };
  TCC.attribution();

  document.addEventListener('click', function (e) {
    var co = e.target.closest && e.target.closest('[data-tcc-checkout]');
    if (co) { TCC.track('begin_checkout', { ecommerce: TCC.ecommerce(TCC.lastItems || []), method: 'checkout_link' }); return; }
    var tel = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (tel) TCC.track('click_to_call', { link_url: tel.getAttribute('href') });
    var el = e.target.closest && e.target.closest('[data-tcc-event]');
    if (!el) return;
    var p = {};
    if (el.dataset.tccSetup) p.setup = el.dataset.tccSetup;
    if (el.href) p.link_url = el.getAttribute('href');
    TCC.track(el.dataset.tccEvent, p);
  });

  /* ---------- helpers ---------- */
  TCC.money = function (cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function isDefault(product) { return !product || product.variants.length <= 1 && (product.options.length <= 1) ; }

  /* Catalog option values, including ones past Shopify's 250-variant storefront cap. */
  function catalogOption(product, i) {
    var name = product.options[i];
    var list = product.optionValues || [];
    for (var n = 0; n < list.length; n++) if (list[n].name === name) return list[n];
    return null;
  }
  /* Selections are stored as {0: value, 1: value}, not an array. */
  function selectionList(sel) {
    if (!sel) return [];
    if (Array.isArray(sel)) return sel.slice();
    var list = [], i = 0;
    while (Object.prototype.hasOwnProperty.call(sel, i)) { list.push(sel[i]); i++; }
    return list;
  }
  /* The product page, asked for these option-value ids, returns the real variant in JSON-LD
   * even when that variant is past the 250 the storefront JSON includes. */
  function variantFromPage(html, sel) {
    sel = selectionList(sel);
    var re = /<script type="application\/ld\+json">([\s\S]*?)<\/script>/g, m, data, list, item, parts, idm, price;
    while ((m = re.exec(html))) {
      try { data = JSON.parse(m[1]); } catch (e) { continue; }
      list = data.hasVariant || [];
      if (!Array.isArray(list)) list = [list];
      for (var n = 0; n < list.length; n++) {
        item = list[n];
        parts = String(item.name || '').split(' - ').pop().split(' / ').map(function (s) { return s.trim(); });
        if (parts.length < sel.length || !sel.every(function (v, idx) { return parts[idx] === v; })) continue;
        idm = String(item['@id'] || (item.offers && item.offers.url) || '').match(/variant=(\d+)/);
        price = item.offers && parseFloat(item.offers.price);
        if (!idm || !(price >= 0)) continue;
        return {
          id: +idm[1],
          title: parts.slice(0, sel.length).join(' / '),
          options: sel.slice(),
          price: Math.round(price * 100),
          available: !item.offers.availability || /InStock/.test(item.offers.availability),
          sku: item.sku || '',
          image: typeof item.image === 'string' ? item.image : (item.image && (item.image.url || item.image[0])) || null
        };
      }
    }
    return null;
  }
  /* sequential option compatibility: values for option i given selections of options < i */
  function valuesFor(product, i, sel) {
    var seen = {}, out = [];
    product.variants.forEach(function (v) {
      for (var j = 0; j < i; j++) if (sel[j] != null && v.options[j] !== sel[j]) return;
      var val = v.options[i];
      if (!(val in seen)) { seen[val] = out.length; out.push({ value: val, available: v.available }); }
      else if (v.available) out[seen[val]].available = true;
    });
    var catalog = catalogOption(product, i);
    if (catalog) {
      /* Shopify only puts 250 variants on the page. A value missing from that slice can still
         be a real combination (QueuePro 13 FT, later finishes). Always offer the full catalog.
         The product page resolves the variant after the buyer picks it. */
      catalog.values.forEach(function (cv) {
        if (cv.value in seen) return;
        seen[cv.value] = out.length;
        out.push({ value: cv.value, available: true, remote: true });
      });
    }
    return out;
  }
  function normalise(product, sel) {
    sel = sel || {};
    for (var i = 0; i < product.options.length; i++) {
      var vals = valuesFor(product, i, sel);
      var ok = vals.some(function (x) { return x.value === sel[i] && x.available; });
      if (!ok) {
        var first = vals.filter(function (x) { return x.available; })[0] || vals[0];
        sel[i] = first ? first.value : null;
      }
    }
    return sel;
  }
  function variantFor(product, sel) {
    return product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; });
    })[0] || null;
  }
  /* SKU shown on cards and setup lines: the exact variant SKU once the chosen options narrow it to one variant, else the
   * SKU stem shared by the remaining variants (e.g. "TCC-QM550-…"). Always taken from the product's own variants. */
  function skuStem(list) {
    var skus = list.map(function (v) { return v.sku || ''; }).filter(Boolean);
    if (!skus.length) return '';
    var p = skus[0];
    skus.forEach(function (x) { while (p && x.indexOf(p) !== 0) p = p.slice(0, -1); });
    if (p === skus[0] && skus.every(function (x) { return x === p; })) return p;
    var d = p.lastIndexOf('-'); if (d > 3) p = p.slice(0, d + 1);
    return p ? p + '\u2026' : '';
  }
  function skuFor(product, sel) {
    sel = sel || {};
    var m = product.variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); });
    var exact = m.length === 1 || (m.length > 1 && m.every(function (v) { return v.sku === m[0].sku; }));
    return { sku: exact ? (m[0].sku || '') : skuStem(m.length ? m : product.variants), exact: exact };
  }
  function skuHTML(product, sel, cls) {
    var r = skuFor(product, sel); if (!r.sku) return '';
    return '<span class="' + cls + '" data-tcc-sku="' + esc(r.sku) + '" data-tcc-sku-exact="' + r.exact + '"' + (r.exact ? '' : ' title="Exact SKU shows once the options are chosen"') + '>SKU: ' + esc(r.sku) + '</span>';
  }
  function firstAvailable(product) {
    return product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
  }
  function optEvent(name) {
    if (/finish|metal|post colou?r/i.test(name)) return 'builder_select_finish';
    if (/length|size|ft|feet/i.test(name)) return 'builder_select_length';
    if (/colou?r/i.test(name)) return 'builder_select_color';
    return 'builder_select_option';
  }

  /* ---------- cart ----------
   * One POST /cart/add.js with every real variant + quantity (posts, ropes, extras).
   * On success, hand the response to the theme's <cart-provider> so its drawer/notification refreshes;
   * otherwise show an inline confirmation with View cart / Checkout links. */
  TCC.addItems = function (items) {
    var provider = document.querySelector('cart-provider');
    var features = (provider && provider.features) || {};
    var body = { items: items };
    var sections = [];
    if (features.notification) sections.push('r_cart-notification');
    if (features.cart) sections.push('r_cart');
    if (sections.length) { body.sections = sections; body.sections_url = root() + 'cart'; }
    if (features.notification) body.attributes = { notification_items_variant_ids: items.map(function (i) { return i.id; }).join(',') };
    return fetch(root() + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || ('HTTP ' + r.status)); e.status = r.status; throw e; }
        if (provider && typeof provider._publishUpdates === 'function' && (features.drawer || features.notification || features['cart-total'] || features.counter)) {
          try {
            return Promise.resolve(provider._publishUpdates(j)).then(function () {
              return { cart: j, drawer: !!(features.drawer || features.notification) };
            }, function () { return { cart: j, drawer: false }; });
          } catch (err) { /* keep the cart confirmation if the drawer cannot refresh */ }
        }
        return { cart: j, drawer: false };
      });
    });
  };
  /* Cart permalink -> replaces the cart and redirects to checkout (302 to Shop Pay on this store, tested).
   * Format verified against /workspace/tcc-data/cart-test-results.json: /cart/<variant_id>:<qty>,<variant_id>:<qty> */
  TCC.permalink = function (items, base, withAttr) {
    var url = (base || '') + '/cart/' + items.map(function (i) { return i.id + ':' + i.quantity; }).join(',');
    var q = [];
    if (withAttr !== false) {
      q.push('attributes[source]=lp_commercial_stanchions');
      var a = TCC.attribution();
      ATTR_KEYS.forEach(function (k) { if (a[k]) q.push('attributes[' + k + ']=' + encodeURIComponent(a[k])); });
    }
    return url + (q.length ? '?' + q.join('&') : '');
  };
  TCC.lastItems = [];
  function cleanItems(items) { return items.map(function (it) { return { id: it.id, quantity: it.quantity, properties: it.properties }; }); }
  function setCartAttributes() {
    var a = TCC.attribution(), attrs = { source: 'lp_commercial_stanchions' };
    ATTR_KEYS.forEach(function (k) { if (a[k]) attrs[k] = a[k]; });
    return fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
  }
  /* Buy now: track add_to_cart + begin_checkout BEFORE the redirect (dataLayer is synchronous; wait max 300 ms for GTM/gtag). */
  TCC.buyNow = function (items, meta, statusEl) {
    if (!items.length) return;
    var eco = TCC.ecommerce(items);
    TCC.track('add_to_cart', { ecommerce: eco, setup: meta.setup, source: meta.source + '_buy_now', method: 'buy_now' });
    var link = TCC.permalink(cleanItems(items), window.TCC_PREVIEW ? window.TCC_PREVIEW.store : root().replace(/\/$/, ''));
    var gone = false, go = function () { if (gone) return; gone = true; if (window.TCC_PREVIEW) { if (statusEl) statusEl.innerHTML = '<strong>Preview:</strong> Buy now would open Shop Pay checkout. <a href="' + esc(link) + '" target="_blank" rel="noopener">Open permalink</a>'; } else { location.href = link; } };
    TCC.track('begin_checkout', { ecommerce: eco, setup: meta.setup, source: meta.source, method: 'buy_now', eventCallback: go, eventTimeout: 300 });
    setTimeout(go, 300);
    return link;
  };

  function doAdd(btn, statusEl, items, meta, strings) {
    if (!items.length || btn.disabled) return;
    var builder = btn.closest('[data-tcc-builder]');
    var mobileBtn = builder && builder.querySelector('[data-tcc-mbar-add]');
    var buttons = mobileBtn ? [btn, mobileBtn] : [btn];
    buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); b.classList.add('is-loading'); });
    statusEl.classList.remove('is-error'); statusEl.textContent = '';
    var eco = TCC.ecommerce(items);
    var clean = cleanItems(items);
    var done = function () {
      buttons.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); b.classList.remove('is-loading'); });
      if (builder) builder.dispatchEvent(new CustomEvent('tcc:cart-idle'));
    };
    if (window.TCC_PREVIEW) {
      var link = TCC.permalink(clean, window.TCC_PREVIEW.store);
      statusEl.innerHTML = '<strong>Preview:</strong> nothing was added (static page). <a href="' + esc(link) + '" target="_blank" rel="noopener">Open real cart</a>';
      TCC.lastItems = items;
      TCC.track('add_to_cart', { ecommerce: eco, setup: meta.setup, source: meta.source, method: 'ajax', preview: true });
      done(); return;
    }
    TCC.addItems(clean).then(function (res) {
      TCC.lastItems = items;
      TCC.track('add_to_cart', { ecommerce: eco, setup: meta.setup, source: meta.source, method: 'ajax' });
      setCartAttributes();
      statusEl.innerHTML = esc(strings.added) + ' <a href="' + root() + 'cart">' + esc(strings.viewCart) + '</a> · <a href="' + root() + 'checkout" data-tcc-checkout>' + esc(strings.checkout) + '</a>';
    }).catch(function (e) {
      statusEl.classList.add('is-error');
      statusEl.textContent = (e && e.message ? e.message + ' ' : '') + strings.error;
    }).then(done);
  }
  var DEFAULT_STRINGS = { added: 'Added to cart.', viewCart: 'View cart', checkout: 'Checkout', error: 'Could not add this setup. Please try again or contact us.' };

  /* ---------- option buttons (shared) ---------- */
  function optionGroup(key, values, current, visibleCount, popular, expanded) {
    var vals = values.slice();
    if (popular && popular.length) {
      vals.sort(function (a, b) {
        var ia = popular.indexOf(a.value.toLowerCase()), ib = popular.indexOf(b.value.toLowerCase());
        return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib);
      });
    }
    var hiddenSel = false;
    var html = vals.map(function (v, i) {
      var hide = !expanded && visibleCount && i >= visibleCount;
      if (hide && v.value === current) { hide = false; hiddenSel = true; }
      return '<button type="button" class="tcc-chip' + (v.value === current ? ' is-selected' : '') + (hide ? ' is-hidden' : '') + '" data-key="' + esc(key) + '" data-value="' + esc(v.value) + '" aria-pressed="' + (v.value === current) + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.value) + (v.available ? '' : ' <small>(sold out)</small>') + '</button>';
    }).join('');
    var hiddenCount = !expanded && visibleCount ? Math.max(0, vals.length - visibleCount - (hiddenSel ? 1 : 0)) : 0;
    if (hiddenCount > 0) html += '<button type="button" class="tcc-chip tcc-chip--more" data-more="' + esc(key) + '">More (' + hiddenCount + ')</button>';
    return '<div class="tcc-chips" role="group">' + html + '</div>';
  }

  /* ---------- finish-aware imagery (real variant images only, never recolored) ---------- */
  function swapImage(media, src, isVariant) {
    if (!media) return;
    var img = media.querySelector('[data-tcc-card-img]');
    if (!img) {
      img = document.createElement('img'); img.className = 'tcc-card__img'; img.setAttribute('data-tcc-card-img', ''); img.alt = '';
      media.innerHTML = ''; media.appendChild(img);
    }
    if (!img.dataset.defaultSrc) { img.dataset.defaultSrc = img.currentSrc || img.src || ''; img.dataset.defaultSrcset = img.getAttribute('srcset') || ''; }
    var target = src || img.dataset.defaultSrc;
    if (!target || img.dataset.shown === target) return;
    img.dataset.shown = target;
    img.classList.add('is-fading');
    var pre = new Image();
    pre.onload = pre.onerror = function () {
      if (img.dataset.shown !== target) return;
      if (src) img.removeAttribute('srcset'); else if (img.dataset.defaultSrcset) img.setAttribute('srcset', img.dataset.defaultSrcset);
      img.src = target;
      media.classList.toggle('is-variant-img', !!(src && isVariant));
      requestAnimationFrame(function () { img.classList.remove('is-fading'); });
    };
    pre.src = target;
  }
  TCC.swapImage = swapImage;

  /* ---------- Ready-to-Go cards ---------- */
  function initReady(card) {
    if (card.__tcc) return; card.__tcc = true;
    var dataEl = card.querySelector('[data-tcc-components]');
    if (!dataEl) return;
    var comps; try { comps = JSON.parse(dataEl.textContent); } catch (e) { return; }
    comps = comps.filter(function (c) { return c.product; });
    var sels = comps.map(function (c) { return normalise(c.product, {}); });
    var choices = card.querySelector('[data-tcc-choices]');
    var totalEl = card.querySelector('[data-tcc-total]');
    var btn = card.querySelector('[data-tcc-ready-add]');
    var status = card.querySelector('[data-tcc-status]');
    var media = card.querySelector('.tcc-card__media');
    var overrides = [];
    try { overrides = JSON.parse((card.closest('section') || document).querySelector('[data-tcc-finish-images]').textContent).filter(Boolean); } catch (e) {}
    var touched = false;
    var bubbleArt = card.querySelector('[data-tcc-bubble-art]');
    function updateBubble() {
      if (!bubbleArt) return;
      var c0 = comps[0], v0 = variantFor(c0.product, sels[0]);
      var src = (v0 && v0.image) || null;
      if (src) {
        var im = bubbleArt.querySelector('img');
        if (!im) { im = document.createElement('img'); im.alt = ''; bubbleArt.innerHTML = ''; bubbleArt.appendChild(im); }
        if (im.getAttribute('src') !== src) { im.classList.add('is-fading'); var pre = new Image(); pre.onload = pre.onerror = function () { im.src = src; requestAnimationFrame(function () { im.classList.remove('is-fading'); }); }; pre.src = src; }
        return;
      }
      if (c0.product.image && !touched) return; /* keep product photo until buyer picks a finish without a variant photo */
      var rope = comps[1] && /rope/i.test(comps[1].product.title);
      bubbleArt.innerHTML = renderSetupSVG({ sys: rope ? 'rope' : 'belt', n: Math.min(c0.qty, 4), finish: optVal(c0.product, sels[0], /finish|post colou?r|metal/i),
        color: rope ? optVal(comps[1].product, sels[1], /colou?r/i) : optVal(c0.product, sels[0], /belt colou?r|^colou?r/i), mini: true });
    }
    function pickImage() {
      updateBubble();
      if (!touched || card.dataset.swapMain !== 'true') return;
      var name = (card.dataset.setupName || '').toLowerCase();
      for (var ci = 0; ci < comps.length; ci++) {
        if (!comps[ci].selectable) continue;
        var vals = Object.keys(sels[ci]).map(function (k) { return String(sels[ci][k] || '').toLowerCase(); });
        var o = overrides.filter(function (x) { return vals.indexOf(x.finish) > -1 && (!x.setup || x.setup === name); })[0];
        if (o) return swapImage(media, o.src, false);
      }
      for (ci = 0; ci < comps.length; ci++) {
        if (!comps[ci].selectable) continue;
        var v = variantFor(comps[ci].product, sels[ci]);
        if (v && v.image) return swapImage(media, v.image, true);
      }
      swapImage(media, null, false);
    }

    function render() {
      var html = '';
      comps.forEach(function (c, ci) {
        if (!c.selectable || isDefault(c.product)) return;
        c.product.options.forEach(function (name, oi) {
          var vals = valuesFor(c.product, oi, sels[ci]);
          if (vals.length < 2) return;
          html += '<label class="tcc-field"><span>' + esc(name) + '</span><select data-ci="' + ci + '" data-oi="' + oi + '">' +
            vals.map(function (v) { return '<option value="' + esc(v.value) + '"' + (v.value === sels[ci][oi] ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.value) + '</option>'; }).join('') + '</select></label>';
        });
      });
      choices.innerHTML = html;
      var total = 0, ok = true;
      comps.forEach(function (c, ci) { var v = variantFor(c.product, sels[ci]); if (!v || !v.available) ok = false; total += (v ? v.price : 0) * c.qty; });
      if (totalEl) totalEl.textContent = TCC.money(total);
      if (btn) btn.disabled = !ok;
      pickImage();
    }
    choices.addEventListener('change', function (e) {
      var s = e.target; if (!s.matches('select')) return;
      var ci = +s.dataset.ci, oi = +s.dataset.oi;
      sels[ci][oi] = s.value; touched = true;
      for (var j = oi + 1; j < comps[ci].product.options.length; j++) sels[ci][j] = null;
      normalise(comps[ci].product, sels[ci]);
      TCC.track(optEvent(comps[ci].product.options[oi]).replace('builder_', 'ready_'), { setup: card.dataset.setupName, option: comps[ci].product.options[oi], value: s.value });
      render();
    });
    if (btn) btn.addEventListener('click', function () {
      TCC.track('select_ready_setup', { setup: card.dataset.setupName });
      var items = comps.map(function (c, ci) {
        var v = variantFor(c.product, sels[ci]);
        return { id: v.id, quantity: c.qty, _price: v.price, _name: c.product.title, _variant: v.title, _sku: v.sku, properties: { _tcc_setup: card.dataset.cartLabel } };
      });
      doAdd(btn, status, items, { setup: card.dataset.setupName, source: 'ready_to_go' }, DEFAULT_STRINGS);
    });
    render();
  }


  /* ---------- live setup illustration (SVG, not to scale) ---------- */
  /* Finish families: every post / cassette finish option in the store maps to one family (v6.3: named keys, so tests can
   * check that no option falls back to the unknown grey). Order matters: the specific rules come first. */
  var FINISH = [
    [/polished.*(stainless|chrome)|chrome|polished steel/i, 'polished', ['#7d838a', '#f7f9fb', '#9ba1a8']],
    [/satin brass|brushed brass/i, 'satin-brass', ['#9c8248', '#d9c189', '#a68a4c']],
    [/pewter/i, 'pewter', ['#5f6468', '#a3a8ad', '#6c7175']],
    [/satin.*(stainless|steel)|brushed|stainless|aluminum|nickel/i, 'satin', ['#9da2a8', '#d4d7db', '#a7acb1']],
    [/english antique|antique brass/i, 'antique-brass', ['#4d3a1c', '#9c7f48', '#5c4624']],
    [/brass|gold/i, 'brass', ['#9a7016', '#f5d77f', '#b5862a']],
    [/copper/i, 'copper', ['#7a3f1d', '#d38a5c', '#8d4a24']],
    [/bronze|antique/i, 'bronze', ['#3f2c1d', '#7d5f42', '#4a3524']],
    [/yellow/i, 'yellow', ['#d9a900', '#ffd84d', '#e0b000']],
    [/orange/i, 'orange', ['#c85a00', '#ff9a3c', '#d86a0a']],
    [/red/i, 'red', ['#99121f', '#e0424f', '#a8151f']],
    [/black|dark/i, 'black', ['#111', '#3a3a3a', '#1b1b1b']]
  ];
  var COLORS = { black: '#1b1b1b', red: '#c8102e', blue: '#1f4fbf', 'dark blue': '#14275e', navy: '#14275e', 'light blue': '#6fb3e8', yellow: '#f5c400',
    maroon: '#6d1a2a', burgundy: '#6d1a2a', green: '#1f7a3a', 'light green': '#7cc56b', 'dark green': '#0f4d26', 'hunter green': '#1d4d2b', orange: '#f07a12',
    grey: '#7a7f86', gray: '#7a7f86', 'dark grey': '#4a4f55', 'dark gray': '#4a4f55', 'light gray': '#b9bec4', 'light grey': '#b9bec4', purple: '#5b2a86', pink: '#e86aa6', white: '#f4f4f4', magenta: '#c2187a',
    'antique gold': '#b8913a', gold: '#c9a227', hemp: '#c8ad7f', natural: '#c8ad7f', brown: '#6b4423', 'light brown': '#a47551', olive: '#6b6b2a', teal: '#127a7a', tan: '#c9a77c',
    'fluorescent orange': '#ff5f1f', 'fluorescent yellow': '#d8f52a', 'fluorescent pink': '#ff3fa4' };
  var UNKNOWN = '#9aa0a6';
  function lookupColor(name) { var n = String(name || '').toLowerCase().trim(); return COLORS[n] || null; }
  function colorHex(name) { return lookupColor(name) || UNKNOWN; }
  var NEUTRAL_STOPS = ['#c5cad1', '#e2e5e9', '#c9ced5'];   /* no finish chosen yet: light neutral grey */
  function finishInfo(name) {
    if (!name) return { key: 'neutral', stops: NEUTRAL_STOPS };
    for (var i = 0; i < FINISH.length; i++) if (FINISH[i][0].test(name)) return { key: FINISH[i][1], stops: FINISH[i][2] };
    return { key: 'unknown', stops: ['#6b7178', '#b6bbc1', '#7a8087'] };
  }
  function finishStops(name) { return finishInfo(name).stops; }
  TCC.finishInfo = finishInfo;
  function optVal(product, sel, re) {
    if (!product) return '';
    for (var i = 0; i < product.options.length; i++) if (re.test(product.options[i])) return sel[i] || '';
    return '';
  }
  function shade(hex, f) {
    var h = hex.replace('#', ''); if (h.length === 3) h = h.replace(/./g, '$&$&');
    var c = [0, 2, 4].map(function (i) { var v = parseInt(h.substr(i, 2), 16); return Math.max(0, Math.min(255, Math.round(f < 0 ? v * (1 + f) : v + (255 - v) * f))); });
    return '#' + c.map(function (v) { return ('0' + v.toString(16)).slice(-2); }).join('');
  }
  /* Belt colour / pattern options (QueueMaster 550, QueuePro 250, WallMaster 400, Tensabarrier 897), parsed into a drawable spec:
   * solid | diagonal ("X/Y Diagonal", "X/Y Chevron") | stripe ("X/Y Stripe", "X/Reflective Stripe") | text ("Yellow CAUTION-WET FLOOR",
   * "Caution - Do Not Enter", custom print). Text belts were checked against the store photos: yellow = black text, red / black = white text. */
  function beltSpec(name) {
    var n = String(name || '').trim(), m, s = { name: n, kind: 'solid', base: null, alt: null, text: '', ink: '#111' };
    if (!n) return { name: '', kind: 'none', base: '#b9bfc7', alt: null, text: '', ink: '#111', known: true };
    if (/custom/i.test(n)) { s.kind = 'text'; s.base = COLORS.yellow; s.text = 'TEXT - LOGO'; s.ink = '#1f4fbf'; }
    else if ((m = n.match(/^(.+?)\s*\/\s*(.+?)\s+(diagonal|chevron)$/i))) { s.kind = 'diagonal'; s.base = lookupColor(m[1]); s.alt = lookupColor(m[2]); }
    else if ((m = n.match(/^(.+?)\s*\/\s*reflective stripe$/i))) { s.kind = 'stripe'; s.base = lookupColor(m[1]); s.alt = '#e9eef2'; s.lines = 1; }
    else if ((m = n.match(/^(.+?)\s*\/\s*(.+?)\s+stripe$/i))) { s.kind = 'stripe'; s.base = lookupColor(m[1]); s.alt = lookupColor(m[2]); s.lines = /white/i.test(m[2]) ? 2 : 1; }
    else if (/^caution\s*-\s*do not enter$/i.test(n)) { s.kind = 'text'; s.base = COLORS.yellow; s.text = 'CAUTION - DO NOT ENTER'; s.ink = '#111'; }
    else if ((m = n.match(/^(Yellow|Red|Black)\s+([A-Z][A-Z0-9 !\-]+)$/))) { s.kind = 'text'; s.base = lookupColor(m[1]); s.ink = /yellow/i.test(m[1]) ? '#111' : '#fff'; s.text = m[2].replace(/DONOT/, 'DO NOT'); }
    else s.base = lookupColor(n);
    s.known = !!s.base && (s.kind === 'solid' || s.kind === 'text' || !!s.alt);
    if (!s.base) s.base = UNKNOWN;
    if (!s.alt && (s.kind === 'diagonal' || s.kind === 'stripe')) s.alt = '#1b1b1b';
    return s;
  }
  TCC.beltSpec = beltSpec;
  /* Paint for a belt: rect fill (side view), stroke (top view) and an overlay for printed text. */
  function beltPaint(name, id) {
    var b = beltSpec(name), defs = '', fill = b.base, plan = b.base;
    if (b.kind === 'diagonal') {
      defs = '<pattern id="' + id + '" width="12" height="12" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="12" height="12" fill="' + b.base + '"/><rect width="6" height="12" fill="' + b.alt + '"/></pattern>';
      fill = plan = 'url(#' + id + ')';
    } else if (b.kind === 'stripe') {
      defs = '<pattern id="' + id + '" width="1" height="1" patternContentUnits="objectBoundingBox"><rect width="1" height="1" fill="' + b.base + '"/>' +
        (b.lines === 2 ? '<rect y=".22" width="1" height=".14" fill="' + b.alt + '"/><rect y=".64" width="1" height=".14" fill="' + b.alt + '"/>' : '<rect y=".36" width="1" height=".28" fill="' + b.alt + '"/>') + '</pattern>';
      fill = 'url(#' + id + ')';
    }
    return { spec: b, defs: defs, fill: fill, plan: plan, tall: b.kind === 'text',
      band: function (x, y, w, h) {
        var out = '<rect class="tcc-band" data-kind="' + b.kind + '" x="' + x.toFixed(1) + '" y="' + y + '" width="' + w.toFixed(1) + '" height="' + h + '" fill="' + fill + '"/>';
        if (b.kind === 'text' && w > 24) {
          /* keep the print clear of the post caps (about 11 px either side); shrink the type before squeezing it */
          var room = w - 30, fs = Math.min(h - 4, 10), per = b.text.length * .62, reps = Math.max(1, Math.floor((room + 26) / (per * fs + 26)));
          var slot = (room - 26 * (reps - 1)) / reps;
          if (reps === 1) fs = Math.max(5.5, Math.min(fs, slot / per));
          var est = per * fs;
          for (var k = 0; k < reps; k++) {
            var cx = x + 15 + slot / 2 + k * (slot + 26), fit = Math.min(slot, est);
            out += '<text class="tcc-band__text" x="' + cx.toFixed(1) + '" y="' + (y + h / 2 + fs * .36).toFixed(1) + '" text-anchor="middle" font-size="' + fs.toFixed(1) + '" font-weight="800" fill="' + b.ink + '"' +
              (fit < est - .5 ? ' textLength="' + fit.toFixed(1) + '" lengthAdjust="spacingAndGlyphs"' : '') + '>' + esc(b.text) + '</text>';
          }
        }
        return out;
      } };
  }
  /* Rope paint: velour = smooth with a soft sheen, braided = twisted (diagonal) pattern. */
  function ropePaint(name, kind, id) {
    var base = name ? colorHex(name) : '#b9bfc7', braided = kind === 'braided';
    return { kind: braided ? 'braided' : 'velour', base: base, known: !name || !!lookupColor(name),
      defs: braided ? '<pattern id="' + id + '" width="6" height="6" patternUnits="userSpaceOnUse" patternTransform="rotate(-40)"><rect width="6" height="6" fill="' + base + '"/><rect width="2.2" height="6" fill="' + shade(base, base === '#1b1b1b' ? .28 : -.35) + '"/></pattern>' : '',
      stroke: braided ? 'url(#' + id + ')' : base };
  }
  function postSVG(x, gid, rope) {
    var top = rope ? '<circle cx="' + x + '" cy="52" r="9" fill="url(#' + gid + ')"/>' : '<rect x="' + (x - 11) + '" y="50" width="22" height="22" rx="4" fill="url(#' + gid + ')"/>';
    return '<ellipse cx="' + x + '" cy="200" rx="30" ry="7" fill="rgba(11,27,51,.12)"/>' +
      '<path d="M' + (x - 28) + ' 196 Q' + x + ' 186 ' + (x + 28) + ' 196 L' + (x + 28) + ' 199 Q' + x + ' 204 ' + (x - 28) + ' 199Z" fill="url(#' + gid + ')"/>' +
      '<rect class="tcc-node" x="' + (x - 6) + '" y="58" width="12" height="134" rx="3" fill="url(#' + gid + ')"/>' + top;
  }
  function gradDef(id, stops) { return '<linearGradient id="' + id + '" x1="0" x2="1"><stop offset="0" stop-color="' + stops[0] + '"/><stop offset=".45" stop-color="' + stops[1] + '"/><stop offset="1" stop-color="' + stops[2] + '"/></linearGradient>'; }
  function svgData(fi, o, bp, rp) {
    var d = ' data-post-family="' + fi.key + '" data-post-color="' + fi.stops[1] + '"';
    if (rp) d += ' data-rope-kind="' + rp.kind + '" data-rope-color="' + rp.base + '" data-rope-known="' + rp.known + '"';
    else if (bp) d += ' data-belt-kind="' + bp.spec.kind + '" data-belt-base="' + bp.spec.base + '" data-belt-alt="' + (bp.spec.alt || '') + '" data-belt-text="' + esc(bp.spec.text) + '" data-belt-known="' + bp.spec.known + '"';
    return d;
  }
  function renderSetupSVG(o) {
    var W = 600, gid = 'tccg' + Math.random().toString(36).slice(2, 7), pid = gid + 'p';
    var fi = finishInfo(o.finish), rope = o.sys === 'rope', bp = rope ? null : beltPaint(o.color, pid), rp = rope ? ropePaint(o.color, o.ropeKind, pid) : null;
    var defs = gradDef(gid, fi.stops) + (bp ? bp.defs : rp.defs);
    var body = '<rect x="0" y="204" width="' + W + '" height="16" fill="#eef1f6"/>';
    var shown = Math.min(o.n, 8), more = o.n > shown;
    if (o.sys === 'wall') {
      /* wall plate + cassette (body colour) on the left wall, belt stretched across the opening to a receiver on the right wall */
      var hatch = '<pattern id="' + gid + 'h" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="8" height="8" fill="#e3e7ee"/><rect width="2" height="8" fill="#d2d8e1"/></pattern>';
      defs += hatch;
      var bh = bp.tall ? 16 : 12;
      body += '<rect x="14" y="30" width="30" height="174" fill="url(#' + gid + 'h)"/><rect x="' + (W - 44) + '" y="30" width="30" height="174" fill="url(#' + gid + 'h)"/>' +
        '<rect x="44" y="66" width="8" height="64" rx="2" fill="#5b6678"/>' +
        '<rect class="tcc-node" x="52" y="70" width="40" height="56" rx="7" fill="url(#' + gid + ')"/><rect x="88" y="90" width="6" height="16" rx="2" fill="#3b4453"/>' +
        bp.band(94, 98 - bh / 2, W - 160, bh) +
        '<rect x="' + (W - 66) + '" y="86" width="22" height="24" rx="4" fill="' + (o.receiver ? '#5b6678' : 'none') + '" stroke="#5b6678" stroke-width="2" stroke-dasharray="' + (o.receiver ? '0' : '4 3') + '"/>' +
        '<text x="' + (W / 2) + '" y="190" text-anchor="middle" font-size="15" fill="#5b6678">' + (o.receiver === false ? 'no receiver' : 'opening') + '</text>';
    } else {
      var gap = (W - 120) / Math.max(1, shown - 1), xs = [];
      for (var i = 0; i < shown; i++) xs.push(shown === 1 ? W / 2 : 60 + i * gap);
      for (i = 0; i < xs.length - 1; i++) {
        if (rope) {
          var mx = (xs[i] + xs[i + 1]) / 2, d = 'M' + xs[i] + ' 62 Q' + mx + ' 118 ' + xs[i + 1] + ' 62';
          body += '<path class="tcc-rope" data-kind="' + rp.kind + '" d="' + d + '" fill="none" stroke="' + rp.stroke + '" stroke-width="' + (rp.kind === 'braided' ? 7 : 9) + '" stroke-linecap="round"/>' +
            (rp.kind === 'velour' && o.color ? '<path d="' + d + '" fill="none" stroke="#fff" stroke-opacity=".28" stroke-width="2" stroke-linecap="round" transform="translate(0 -2)"/>' : '');
        } else {
          var th = bp.tall ? 15 : 11;
          body += bp.band(xs[i], 69.5 - th / 2, xs[i + 1] - xs[i], th);
        }
      }
      xs.forEach(function (x) { body += postSVG(x, gid, rope); });
    }
    var label = o.badge ? o.badge : o.sys === 'wall' ? o.n + (o.n === 1 ? ' wall unit' : ' wall units') : o.n + (rope ? ' posts + ' + Math.max(1, o.n - 1) + ' ropes' : ' posts');
    if (!o.mini) body += '<text x="' + (W - 12) + '" y="24" text-anchor="end" font-size="22" font-weight="800" fill="#0b1b33">' + esc(label) + (more ? ' (8 shown)' : '') + '</text>';
    return '<svg viewBox="0 0 ' + W + ' 220" role="img"' + svgData(fi, o, bp, rp) + ' aria-label="' + esc(label + ', ' + (o.finish || '') + ' ' + (o.color || '')) + '"><defs>' + defs + '</defs>' + body + '</svg>';
  }
  /* Top view (L / U) in the chosen finish and belt: text and stripe belts are drawn in their base colour at this scale. */
  function planArt(geo, finish, color, label, aria) {
    var fi = finishInfo(finish), gid = 'tccp' + Math.random().toString(36).slice(2, 7), bp = beltPaint(color, gid + 'b');
    var svg = planSVG(geo, { label: label, post: 'url(#' + gid + ')', belt: bp.plan, defs: gradDef(gid, fi.stops) + (bp.spec.kind === 'diagonal' ? bp.defs : ''), aria: aria });
    return svg.replace('<svg ', '<svg' + svgData(fi, {}, bp, null) + ' ');
  }
  TCC.renderSetupSVG = renderSetupSVG;

  /* ---------- Build Your Own + belt queue calculator ---------- */
  /* Layouts follow the displays2go "4 simple ways" guide: a post at both ends of every straight run and at
   * every turn; posts shared by two runs are counted once. The calculator builds the actual layout
   * (posts as points, belts as segments) and the post count IS the number of posts in that drawing.
   * BELT WORKING SPACING is ONE config spot: the builder section settings "spacing_11" / "spacing_13"
   * (exposed to JS as cfg.calc.spacing). No recommended working spacing is published for the QueueMaster 550,
   * so when those settings are blank the calculator falls back to the nominal belt length and flags it. */
  var LAYOUTS = ['straight', 'l', 'u'];   /* multi-lane removed in v6; #multi-lane-queue opens U-shape */
  var LANE_FT = 4;        /* 48 in lane width for L and U layouts */
  var TURN_ROOM_FT = 4;   /* 48 in turning room at the open end of each inner lane */
  var MIN_LANE_FT = 3;    /* 36 in minimum lane width */

  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isFinite(n) && n > 0 ? n : 0; }
  function ft(n) { return (Math.round(n * 10) / 10).toLocaleString('en-US') + ' ft'; }
  function postsForRun(len, s) { return len > 0 ? Math.ceil(len / s - 1e-9) + 1 : 0; }
  TCC.postsForRun = postsForRun;
  function runPts(a, b, s) {
    var dx = b[0] - a[0], dy = b[1] - a[1], len = Math.sqrt(dx * dx + dy * dy), k = Math.max(1, Math.ceil(len / s - 1e-9)), out = [];
    for (var j = 0; j <= k; j++) out.push([a[0] + dx * j / k, a[1] + dy * j / k]);
    return out;
  }
  /* Pure layout builder (exported for testing). c = {layout, runs[], width, length, lanes}, s = working spacing (ft).
   * Coordinates in ft, y grows downwards (entry at the bottom). Returns null until the inputs are complete. */
  function shapeGeometry(c, s) {
    if (!s) return null;
    var lay = c.layout, walls = [], entry, exit, notes = [], coverage = 0, lanes = 0, laneW = 0, w = LANE_FT;
    if (lay === 'straight') {
      var Ls = num(c.runs[0]); if (!Ls) return null;
      walls.push([[0, 0], [Ls, 0]]);
      entry = { x: 0, y: -1.8, dir: 'r' }; exit = { x: Ls, y: -1.8, dir: 'r' }; coverage = Ls;
    } else if (lay === 'l') {
      var A = num(c.runs[0]), B = num(c.runs[1]); if (!A || !B) return null;
      if (A <= w || B <= w) return { error: 'short' };
      walls.push([[0, A], [0, 0], [B, 0]]);           /* outside wall: entry leg up, then right */
      walls.push([[w, A], [w, w], [B, w]]);           /* inside wall, one lane (48 in) in */
      entry = { x: w / 2, y: A, dir: 'u' }; exit = { x: B, y: w / 2, dir: 'r' };
      coverage = (A - w / 2) + (B - w / 2); lanes = 1; laneW = w;
    } else if (lay === 'u') {
      var Ll = num(c.length), N = +c.lanes || 0;
      if (!Ll || !N) return null;
      if (Ll <= TURN_ROOM_FT + 1) return { error: 'shortlane' };
      var y = function (i) { return (N - i) * w; }, reachL = [], reachR = [];
      for (var i = 0; i <= N; i++) {
        var outer = i === 0 || i === N, x0 = 0, x1 = Ll;
        if (!outer) { if (i % 2) x1 = Ll - TURN_ROOM_FT; else x0 = TURN_ROOM_FT; }
        walls.push([[x0, y(i)], [x1, y(i)]]);
        if (x0 === 0) reachL.push(i); if (x1 === Ll) reachR.push(i);
      }
      var exitRight = N % 2 === 1;
      [[reachL, 0, !exitRight], [reachR, Ll, exitRight]].forEach(function (side) {
        var r = side[0];
        for (var k = 0; k < r.length - 1; k++) {
          var a = r[k], b = r[k + 1];
          if (side[1] === 0 && a === 0 && b === 1) continue;            /* entry opening */
          if (side[2] && a === N - 1 && b === N) continue;              /* exit opening */
          walls.push([[side[1], y(a)], [side[1], y(b)]]);
        }
      });
      entry = { x: 0, y: y(0) - w / 2, dir: 'r' };
      exit = { x: exitRight ? Ll : 0, y: y(N) + w / 2, dir: exitRight ? 'r' : 'l' };
      coverage = N * Ll; lanes = N; laneW = w;
    } else return null;
    var seen = {}, posts = [], segs = [];
    walls.forEach(function (pl) {
      for (var q = 0; q < pl.length - 1; q++) {
        var pts = runPts(pl[q], pl[q + 1], s);
        for (var j = 0; j < pts.length; j++) {
          var key = pts[j][0].toFixed(2) + ',' + pts[j][1].toFixed(2);
          if (!(key in seen)) { seen[key] = posts.length; posts.push(pts[j]); }
          if (j) segs.push([pts[j - 1], pts[j]]);
        }
      }
    });
    return { layout: lay, posts: posts, segs: segs, entry: entry, exit: exit, count: posts.length, coverage: coverage, lanes: lanes, laneWidth: laneW, notes: notes };
  }
  TCC.shapeGeometry = shapeGeometry;
  function calcPosts(c, s) {
    var g = shapeGeometry(c, s);
    if (!g || g.error) return null;
    return { posts: g.count, coverage: g.coverage, lanes: g.layout === 'l' ? 0 : g.lanes, laneWidth: g.laneWidth, notes: g.notes, spacing: s, layout: g.layout, geo: g };
  }
  TCC.calcPosts = calcPosts;

  /* Top-view drawing of a layout: dots = posts, lines = belts, entry arrow and EXIT mark */
  function arrowMark(x, y, dir, r, mini) {
    var rot = { r: 0, d: 90, l: 180, u: -90 }[dir] || 0;
    return '<g class="tcc-plan__in" transform="translate(' + x.toFixed(1) + ' ' + y.toFixed(1) + ') rotate(' + rot + ')">' +
      (mini ? '' : '<circle r="' + r + '" fill="#fff" stroke="#0b1b33" stroke-width="2"/>') +
      '<path d="M' + (-r * .55) + ' 0H' + (r * .5) + 'M' + (r * .1) + ' ' + (-r * .4) + 'L' + (r * .55) + ' 0L' + (r * .1) + ' ' + (r * .4) + '" fill="none" stroke="' + (mini ? 'currentColor' : '#0b1b33') + '" stroke-width="' + (mini ? 1.6 : 2.4) + '" stroke-linecap="round" stroke-linejoin="round"/></g>';
  }
  function entryTriangle(x, y, dir) {
    var s = 16, rot = { u: 0, r: 90, d: 180, l: -90 }[dir] || 0;
    return '<g transform="translate(' + x.toFixed(1) + ' ' + y.toFixed(1) + ') rotate(' + rot + ')"><path d="M0 ' + (-s * .75).toFixed(1) + ' L' + (s * .7).toFixed(1) + ' ' + (s * .55).toFixed(1) + ' L' + (-s * .7).toFixed(1) + ' ' + (s * .55).toFixed(1) + ' Z" fill="#1F5BD8"/></g>';
  }
  function exitMark(x, y, dir, mini) {
    var w = mini ? 20 : 46, h = mini ? 9 : 20, fs = mini ? 6.5 : 13;
    var cx = x + (dir === 'r' ? w / 2 - 2 : dir === 'l' ? -w / 2 + 2 : 0), cy = y + (dir === 'u' ? -h / 2 : 0);
    return '<g class="tcc-plan__exit"><rect x="' + (cx - w / 2).toFixed(1) + '" y="' + (cy - h / 2).toFixed(1) + '" width="' + w + '" height="' + h + '" rx="2" fill="#fff" stroke="' + (mini ? 'currentColor' : '#0b1b33') + '" stroke-width="' + (mini ? 1 : 1.6) + '"/>' +
      '<text x="' + cx.toFixed(1) + '" y="' + (cy + fs * .36).toFixed(1) + '" text-anchor="middle" font-size="' + fs + '" font-weight="700" fill="' + (mini ? 'currentColor' : '#0b1b33') + '" letter-spacing=".04em">EXIT</text></g>';
  }
  function planSVG(g, o) {
    var mini = !!o.mini;
    var xs = g.posts.map(function (p) { return p[0]; }).concat([g.entry.x, g.exit.x]), ys = g.posts.map(function (p) { return p[1]; }).concat([g.entry.y, g.exit.y]);
    var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs), minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
    var bw = Math.max(1, maxX - minX), bh = Math.max(1, maxY - minY);
    var minFt = 8;
    for (var ai = 0; ai < g.posts.length; ai++) for (var aj = ai + 1; aj < g.posts.length; aj++) {
      var dft = Math.hypot(g.posts[ai][0] - g.posts[aj][0], g.posts[ai][1] - g.posts[aj][1]);
      if (dft > 0.2 && dft < minFt) minFt = dft;
    }
    var W, H, top, padX, padY, off, sc;
    if (mini) {
      W = 120; H = 64; top = 4; padX = 22; padY = 10; off = 7;
      sc = Math.min((W - 2 * padX) / bw, (H - top - 2 * padY) / bh);
    } else {
      /* Size the drawing around the posts so the dots fill the card instead of sitting in a wide empty frame. */
      top = 44; padX = 64; padY = 28; off = 22;
      sc = Math.min(22, Math.max(7, 34 / minFt));
      sc = Math.min(sc, 620 / bw, 460 / bh);
      W = Math.ceil(bw * sc + 2 * padX);
      H = Math.ceil(top + bh * sc + 2 * padY);
    }
    var ox = (W - bw * sc) / 2 - minX * sc, oy = top + (H - top - bh * sc) / 2 - minY * sc;
    var DV = { r: [1, 0], l: [-1, 0], u: [0, -1], d: [0, 1] };
    var P = function (p) { return [ox + p[0] * sc, oy + p[1] * sc]; };
    /* Dots stay large enough to read on the card. Spacing in the drawing sets the cap so a dense layout does not turn into one blob. */
    var minD = 90;
    for (var pi = 0; pi < g.posts.length; pi++) for (var pj = pi + 1; pj < g.posts.length; pj++) {
      var pa = P(g.posts[pi]), pb = P(g.posts[pj]);
      var dist = Math.hypot(pa[0] - pb[0], pa[1] - pb[1]);
      if (dist > 2 && dist < minD) minD = dist;
    }
    var r = mini ? Math.max(1.45, Math.min(2.1, minD * 0.2)) : Math.max(5.5, Math.min(7.5, minD * 0.22));
    var lineW = mini ? 1.15 : Math.max(3.5, Math.min(5, r * 0.62));
    var body = '';
    var stroke = mini ? 'currentColor' : '#1F5BD8';
    var dot = mini ? 'currentColor' : '#0b1b33';
    g.segs.forEach(function (sg) { var a = P(sg[0]), b = P(sg[1]); body += '<line x1="' + a[0].toFixed(1) + '" y1="' + a[1].toFixed(1) + '" x2="' + b[0].toFixed(1) + '" y2="' + b[1].toFixed(1) + '" stroke="' + stroke + '" stroke-width="' + lineW.toFixed(1) + '" stroke-linecap="round"/>'; });
    g.posts.forEach(function (p) { var q = P(p); body += '<circle class="tcc-node" cx="' + q[0].toFixed(1) + '" cy="' + q[1].toFixed(1) + '" r="' + r.toFixed(1) + '" fill="' + dot + '"' + (mini ? '' : ' stroke="#fff" stroke-width="1.5"') + '/>'; });
    var en = P([g.entry.x, g.entry.y]), ex = P([g.exit.x, g.exit.y]), de = DV[g.entry.dir], dx = DV[g.exit.dir];
    en = [en[0] - de[0] * off, en[1] - de[1] * off]; ex = [ex[0] + dx[0] * off * .5, ex[1] + dx[1] * off * .5];
    body += (mini ? arrowMark(en[0], en[1], g.entry.dir, 6, true) : entryTriangle(en[0], en[1], g.entry.dir)) + exitMark(ex[0], ex[1], g.exit.dir, mini);
    if (!mini && o.label) {
      var fs = Math.max(16, Math.min(22, W / 18));
      body = '<rect x="0" y="0" width="' + W + '" height="' + H + '" fill="#fbfcfe"/>' + body + '<text x="' + (W - 12) + '" y="' + (fs + 8) + '" text-anchor="end" font-size="' + fs.toFixed(0) + '" font-weight="800" fill="#0b1b33">' + esc(o.label) + '</text>';
    }
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" class="tcc-plan" role="img" aria-label="' + esc(o.aria || o.label || 'Layout diagram') + '"' + (o.defs ? '><defs>' + o.defs + '</defs>' : '>') + body + '</svg>';
  }
  TCC.planSVG = planSVG;
  /* Option-card diagrams use the same layout builder with sample sizes */
  var SHAPE_SAMPLES = {
    straight: { c: { layout: 'straight', runs: [30] }, s: 10 },
    l: { c: { layout: 'l', runs: [20, 15] }, s: 4 },
    u: { c: { layout: 'u', length: 24, lanes: 3 }, s: 8 }
  };
  var SHAPE_INFO = {
    straight: { name: 'Straight', best: 'Single counter or short waits' },
    l: { name: 'L-shape', best: 'Cashier, coffee shop or concession' },
    u: { name: 'U-shape', best: 'Ticketing, slower service or high volume, airport-style weaving' }
  };

  function initBuilder(el) {
    if (el.__tcc) return; el.__tcc = true;
    var cfg; try { cfg = JSON.parse(el.querySelector('[data-tcc-builder-config]').textContent); } catch (e) { return; }
    var blocks = (cfg.blocks || []).filter(function (b) { return b.product; });
    blocks.forEach(function (b, i) {
      b.idx = i; b.popular = (b.popular || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      b.matchMap = {}; String(b.match || '').split('|').forEach(function (m) { var kv = m.split('='); if (kv.length === 2 && kv[0].trim()) b.matchMap[kv[0].trim().toLowerCase()] = kv[1].trim(); });
      b.capacity = parseInt(b.capacity, 10) || 0;
    });
    var S = cfg.strings, C = cfg.calc || {}, L = cfg.labels || {};
    var steps = el.querySelector('[data-tcc-steps]');
    var summary = el.querySelector('[data-tcc-summary]');
    var totalEl = el.querySelector('[data-tcc-summary-total]');
    var addBtn = el.querySelector('[data-tcc-builder-add]');
    var buyBtn = el.querySelector('[data-tcc-builder-buy]');
    var status = el.querySelector('[data-tcc-builder-status]');
    var started = false, st = null, expanded = {};
    TCC.builderState = function () { return st; };   /* read-only hook for tests / debugging */
    var BELT_LENGTHS = Object.keys(C.spacing || { 11: null, 13: null });

    function of(branch, role) { return blocks.filter(function (b) { return b.branch === branch && b.role === role; }); }
    function optIndex(product, re) { for (var i = 0; i < product.options.length; i++) if (re.test(product.options[i])) return i; return -1; }
    /* Nothing is pre-selected: options stay empty until the buyer picks them. Only options with a single
     * available value are filled in, and picks that become impossible after an earlier change are cleared. */
    function fix(product, sel) {
      for (var i = 0; i < product.options.length; i++) {
        var vals = valuesFor(product, i, sel), avail = vals.filter(function (x) { return x.available; });
        if (sel[i] != null && !avail.some(function (x) { return x.value === sel[i]; })) sel[i] = null;
        if (sel[i] == null && avail.length === 1) sel[i] = avail[0].value;
      }
      return sel;
    }
    function complete(product, sel) { return product.options.every(function (o, i) { return sel[i] != null; }); }
    function chosen(product, sel) { return complete(product, sel) ? variantFor(product, sel) : null; }
    var remoteLookup = {};
    /* Combinations past the 250-variant cap are not in the page JSON. Ask the product page
     * for the option-value ids and keep the variant it returns. */
    function remoteKey(product, sel) {
      if (!product || !complete(product, sel)) return '';
      var ids = [];
      for (var i = 0; i < product.options.length; i++) {
        var spec = catalogOption(product, i);
        var hit = spec && spec.values.filter(function (v) { return v.value === sel[i]; })[0];
        if (!hit || hit.id == null) return '';
        ids.push(hit.id);
      }
      return product.id + ':' + ids.join(',');
    }
    function queueRemote(product, sel) {
      if (!product || !product.url || !complete(product, sel) || chosen(product, sel)) return;
      var key = remoteKey(product, sel);
      if (!key || remoteLookup[key]) return;
      /* Wait until the buyer stops tapping. Each lookup downloads the product page,
         and a burst of those requests makes Shopify answer 500. */
      clearTimeout(product._remoteTimer);
      product._remoteTimer = setTimeout(function () {
        if (remoteKey(product, sel) !== key || chosen(product, sel) || remoteLookup[key]) return;
        resolveRemote(product, sel);
      }, 320);
    }
    function resolveRemote(product, sel) {
      if (!product || !product.url || !complete(product, sel) || chosen(product, sel)) return;
      var key = remoteKey(product, sel);
      if (!key || remoteLookup[key]) return;
      remoteLookup[key] = 'pending';
      /* Snapshot the picks. The buyer can change them before this page comes back,
         and the live selection object would no longer match the HTML we asked for. */
      var picked = selectionList(sel);
      var optionIds = key.slice(String(product.id).length + 1);
      var join = product.url.indexOf('?') >= 0 ? '&' : '?';
      var base = product.url + join + 'option_values=' + encodeURIComponent(optionIds);
      var settled = false;
      function finish(variant) {
        if (settled) return;
        settled = true;
        remoteLookup[key] = variant || 'miss';
        if (variant && !product.variants.some(function (v) { return v.id === variant.id; })) product.variants.push(variant);
        var same = product.options.every(function (o, i) { return sel[i] === picked[i]; });
        if (same) render();
      }
      function attempt(left, useSection) {
        var url = base;
        if (useSection && product._section) url += '&section_id=' + encodeURIComponent(product._section);
        fetch(url, { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        }).then(function (html) {
          if (!product._section) {
            var found = String(html).match(/id="shopify-section-(template--\d+__main)"/);
            if (found) product._section = found[1];
          }
          var variant = variantFromPage(html, picked);
          if (!variant && useSection) { attempt(left, false); return; }
          if (!variant && left > 0) { setTimeout(function () { attempt(left - 1, false); }, 450); return; }
          finish(variant);
        }).catch(function () {
          if (left > 0) setTimeout(function () { attempt(left - 1, false); }, 600);
          else finish(null);
        });
      }
      attempt(2, true);
    }

    function reset(system) {
      expanded = {};
      st = { system: system, mode: null, layout: null, runs: ['', '', ''], width: '', length: '', lanes: null, count: null,
        main: null, mainSel: {}, sub: null, subSel: {}, extras: {} };
    }
    function beltIdx() { return st.main != null ? optIndex(blocks[st.main].product, /belt length/i) : -1; }
    function beltValue() { var i = beltIdx(); return i > -1 ? st.mainSel[i] : null; }
    function spacingFor(val) {
      var n = num(String(val || '').match(/[\d.]+/));
      var set = C.spacing && num(C.spacing[String(Math.round(n))]);
      return { s: set || n, confirmed: !!set };
    }
    function calcState() { return { layout: st.layout, runs: st.runs, width: st.width, length: st.length, lanes: st.lanes }; }
    function calcFor(val) { if (st.mode !== 'space' || !st.layout || !val) return null; var sp = spacingFor(val); var r = calcPosts(calcState(), sp.s); if (r) r.confirmed = sp.confirmed; return r; }
    /* Post / unit count for the setup (null until known) */
    function count() {
      if (st.system === 'belt' && st.mode === 'space') { var r = calcFor(beltValue()); return r ? (st.count != null ? st.count : r.posts) : null; }
      return st.count;
    }
    function mainFinish() { return st.main != null ? optVal(blocks[st.main].product, st.mainSel, /finish|metal|post colou?r|body colou?r/i) : ''; }
    function normFinish(s) { return String(s || '').toLowerCase().replace(/\b(steel|smooth|304|plated|effect)\b/g, ' ').replace(/\s+/g, ' ').trim(); }

    /* ----- markup helpers ----- */
    function step(n, title, body, cls) { return '<div class="tcc-step ' + (cls || '') + '"><h4 class="tcc-step__title"><span class="tcc-lp__step-num">' + n + '</span>' + esc(title) + '</h4>' + body + '</div>'; }
    function chips(key, list, current, cls) {
      return '<div class="tcc-chips" role="group">' + list.map(function (o) {
        var on = current != null && String(current) === String(o.value);
        return '<button type="button" class="tcc-chip ' + (cls || '') + (on ? ' is-selected' : '') + '" data-key="' + key + '" data-value="' + esc(o.value) + '" aria-pressed="' + on + '">' + o.label + '</button>';
      }).join('') + '</div>';
    }
    function input(name, label, value, hint) {
      return '<label class="tcc-input"><span>' + esc(label) + '</span><span class="tcc-input__wrap"><input type="number" inputmode="decimal" min="1" max="2000" step="0.5" data-calc="' + name + '" value="' + esc(value) + '" placeholder="' + esc(hint || 'e.g. 20') + '"><em>ft</em></span></label>';
    }
    function productCards(list, current, key, allowNone) {
      var h = '<div class="tcc-choice-grid">';
      if (allowNone) h += '<button type="button" class="tcc-choice' + (current === -1 ? ' is-selected' : '') + '" data-key="' + key + '" data-value="-1" aria-pressed="' + (current === -1) + '"><span class="tcc-choice__label">' + esc(S.none || 'None') + '</span></button>';
      list.forEach(function (b) {
        var p = b.product, from = Math.min.apply(null, p.variants.map(function (v) { return v.price; }));
        var on = current === b.idx, sel = on ? (key === 'main' ? st.mainSel : st.subSel) : null, sv = sel ? chosen(p, sel) : null;
        var thumb = (sv && sv.image) || p.image;
        h += '<button type="button" class="tcc-choice' + (on ? ' is-selected' : '') + '" data-key="' + key + '" data-value="' + b.idx + '" aria-pressed="' + on + '">' +
          (thumb ? '<img src="' + esc(thumb) + '" alt="" loading="lazy" width="160" height="160">' : '') +
          '<span class="tcc-choice__label">' + esc(b.label || p.title) + '</span>' + (b.model ? '<span class="tcc-choice__model">' + esc(b.model) + '</span>' : '') +
          '<span class="tcc-choice__price">' + esc(S.from) + ' ' + TCC.money(from) + '</span>' + skuHTML(p, sel || {}, 'tcc-choice__sku') + '</button>';
      });
      return h + '</div>';
    }
    /* All option groups of one product inside ONE step (sub-labelled), none pre-selected */
    function optionsBlock(block, sel, prefix, skip, beltNote, hide) {
      var p = block.product, h = '';
      p.options.forEach(function (name, oi) {
        if (hide && hide[oi]) return;
        var vals = valuesFor(p, oi, sel);
        if (vals.length < 2) return;
        var key = prefix + ':' + oi, isColor = /colou?r/i.test(name);
        var g = optionGroup(key, vals, sel[oi], isColor ? cfg.visibleColors : cfg.visibleValues, block.popular, expanded[key]);
        if (oi === skip && beltNote) g = g.replace(/(data-value="([^"]+)"[^>]*>)([^<]*)<\/button>/g, function (m, a, v, t) { return a + t + '<small data-belt-out="' + v + '"></small></button>'; });
        h += '<div class="tcc-optgroup"><p class="tcc-calc__sub">' + esc(name) + '</p>' + g + (/tapped for signage/i.test(name) ? '<p class="tcc-calc__hint">Choose Yes to mount a sign frame on this post.</p>' : '') + '</div>';
      });
      return h;
    }
    function countChips(list, unit) {
      var cur = st.count;
      var h = chips('count', list.map(function (q) { return { value: q, label: q + ' ' + (q === 1 ? unit.replace(/s$/, '') : unit) }; }), list.indexOf(cur) > -1 ? cur : null, 'tcc-chip--count');
      if (cur != null) h += '<div class="tcc-count-adjust"><span>' + esc(unit.charAt(0).toUpperCase() + unit.slice(1)) + ':</span>' + stepper(cur) + '</div>';
      return h;
    }
    function stepper(n, key, min) {
      key = key || 'adj'; min = min == null ? 1 : min;
      return '<span class="tcc-qty" role="group" aria-label="Adjust quantity"><button type="button" data-key="' + key + '" data-value="-1" aria-label="One fewer"' + (n <= min ? ' disabled' : '') + '>\u2212</button><span data-tcc-count>' + n + '</span><button type="button" data-key="' + key + '" data-value="1" aria-label="One more">+</button></span>';
    }
    function shapeCards() {
      return '<div class="tcc-shapes" role="group" aria-label="Shape of the line">' + LAYOUTS.map(function (k) {
        var on = st.layout === k, smp = SHAPE_SAMPLES[k], g = shapeGeometry(smp.c, smp.s);
        return '<button type="button" class="tcc-shape' + (on ? ' is-selected' : '') + '" data-key="layout" data-value="' + k + '" aria-pressed="' + on + '">' + planSVG(g, { mini: true, aria: SHAPE_INFO[k].name }) +
          '<span class="tcc-shape__name">' + SHAPE_INFO[k].name + '</span><small class="tcc-shape__best">' + SHAPE_INFO[k].best + '</small></button>';
      }).join('') + '</div>';
    }

    /* ----- step 2: size / quantity ----- */
    function sizeStep() {
      var sys = st.system;
      if (sys !== 'belt') {
        var q = (cfg.quantities[sys] || []).filter(Boolean);
        return step(2, sys === 'rope' ? (L.rope.qty || 'How many posts?') : (L.wall.qty || 'How many openings?'), countChips(q, sys === 'rope' ? 'posts' : 'units') +
          (sys === 'rope' ? '<p class="tcc-calc__hint">One rope fewer than posts for a straight line.</p>' : '<p class="tcc-calc__hint">One wall unit per opening.</p>'));
      }
      var h = chips('mode', [{ value: 'space', label: 'By my space' }, { value: 'count', label: 'By post count' }], st.mode, 'tcc-chip--mode');
      if (st.mode === 'space') {
        h += '<div class="tcc-inline">' + shapeCards();
        var lay = st.layout, hint = '';
        if (lay === 'straight') { h += '<div class="tcc-inputs">' + input('run0', 'Length of the line', st.runs[0], 'e.g. 20') + '</div>'; hint = 'Measure the belt line from end to end.'; }
        else if (lay === 'l') { h += '<div class="tcc-inputs">' + input('run0', 'First leg (entry)', st.runs[0], 'e.g. 20') + input('run1', 'Second leg (to exit)', st.runs[1], 'e.g. 15') + '</div>'; hint = 'Measure the outside edge of each leg. The inside line is set one 48 in lane in.'; }
        else if (lay === 'u') {
          h += '<div class="tcc-inputs">' + input('length', 'Lane length', st.length, 'e.g. 20') + '</div><p class="tcc-calc__sub">Number of lanes</p>' +
            chips('lanes', [2, 3, 4, 5, 6].map(function (v) { return { value: v, label: String(v) }; }), st.lanes, 'tcc-chip--count');
          hint = 'Lanes are 48 in wide. The line turns at the end of each lane (one turn per extra lane).';
        }
        if (lay) h += '<p class="tcc-calc__out tcc-calc__result" data-calc-out="inline" aria-live="polite"></p>';
        h += '<p class="tcc-calc__hint">' + (hint ? esc(hint) + ' ' : '') + '<a href="' + esc(C.floorPlanLink || '#sigitas') + '" data-tcc-event="contact_sigitas" data-tcc-setup="floor_plan">Not sure? Send us your floor plan</a>.</p></div>';
      } else if (st.mode === 'count') {
        h += '<div class="tcc-inline">' + countChips(C.quickPicks || [2, 4, 6, 10], 'posts') + '</div>';
      }
      return step(2, L.belt.qty || 'Size your queue', h);
    }
    function inlineMessage() {
      var g = shapeGeometry(calcState(), 11);
      if (g && g.error === 'short') return 'Each leg needs to be longer than 4 ft.';
      if (g && g.error === 'shortlane') return 'Lanes need to be longer than 5 ft.';
      if (st.layout === 'u' && num(st.length) && !st.lanes) return 'Choose the number of lanes.';
      return 'Enter your measurements to see how many posts you need.';
    }
    function updateCalcOutputs() {
      if (!st || st.system !== 'belt' || st.mode !== 'space') return;
      var inl = steps.querySelector('[data-calc-out="inline"]');
      var per = BELT_LENGTHS.map(function (len) { var sp = spacingFor(len); var r = calcPosts(calcState(), sp.s); return r ? { len: len, r: r } : null; }).filter(Boolean);
      if (inl) inl.innerHTML = per.length ? per.map(function (x) { return '<strong>' + x.r.posts + ' posts</strong> with ' + x.len + ' ft belts'; }).join(' \u00b7 ') : esc(inlineMessage());
      steps.querySelectorAll('[data-belt-out]').forEach(function (o) { var r = calcFor(o.dataset.beltOut); o.textContent = r ? r.posts + ' posts' : ''; });
    }

    /* ----- last step: compatible extras (optional). Nothing is added until the buyer raises the quantity. ----- */
    function extraState(b) { return st.extras[b.idx] || (st.extras[b.idx] = { qty: 0, sel: {} }); }
    /* auto-matched option values: post finish (only when an equivalent finish exists) and fixed values from the block's match setting */
    function extraAuto(b) {
      var p = b.product, auto = {}, fin = normFinish(mainFinish());
      p.options.forEach(function (name, oi) {
        var vals = valuesFor(p, oi, {}).filter(function (x) { return x.available; }).map(function (x) { return x.value; });
        var m = b.matchMap[name.toLowerCase()];
        if (m && vals.indexOf(m) > -1) auto[oi] = m;
        else if (/finish/i.test(name) && fin) { var hit = vals.filter(function (v) { return normFinish(v) === fin; })[0]; if (hit) auto[oi] = hit; }
      });
      /* Pack sizes are not offered. Lock the hidden option to Single (or its only value) so the price stays the single unit. */
      String(b.hide || '').split(',').forEach(function (raw) {
        var want = raw.trim().toLowerCase();
        if (!want) return;
        p.options.forEach(function (name, oi) {
          if (name.toLowerCase() !== want) return;
          var locked = valuesFor(p, oi, {}).filter(function (x) { return x.available; }).map(function (x) { return x.value; });
          var single = locked.filter(function (v) { return /^single$/i.test(v); })[0];
          if (single || locked[0]) auto[oi] = single || locked[0];
        });
      });
      return auto;
    }
    function postAllows(flag) {
      if (st.main == null) return false;
      return String(blocks[st.main].allows || '').toLowerCase().split(',').some(function (s) { return s.trim() === flag; });
    }
    /* Ball tops cannot take a sign. Flat tops and crown tops can. An extra with requires=signs stays hidden until the chosen post allows it. */
    function extraShown(b) {
      var req = String(b.requires || '').toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      return req.every(function (flag) { return postAllows(flag); });
    }
    function recommendedCart() {
      var n = count();
      if (!n) return null;
      var carts = of(st.system, 'extra').filter(function (b) { return extraShown(b) && b.capacity > 0; }).sort(function (a, b) { return a.capacity - b.capacity; });
      if (!carts.length) return null;
      var fit = null;
      carts.forEach(function (b) { if (!fit && b.capacity >= n) fit = b; });
      return fit || carts[carts.length - 1];
    }
    function extraSel(b) {
      var es = extraState(b), auto = extraAuto(b), sel = {};
      b.product.options.forEach(function (o, oi) { sel[oi] = auto[oi] != null ? auto[oi] : es.sel[oi]; });
      fix(b.product, sel);
      return { sel: sel, auto: auto };
    }
    function extrasStep(n) {
      var list = of(st.system, 'extra').filter(extraShown), title = L.extras || 'Add compatible extras (optional)';
      if (!list.length) return step(n, title, '<p class="tcc-calc__hint">' + (st.system === 'wall' ? 'Wall units have no post top, so post-top signs don\u2019t fit. Need signage or a mixed setup? <a href="#quote" data-tcc-event="request_quote" data-tcc-setup="extras_wall" data-tcc-quote-from-builder>Ask us</a>.' : 'Sign frames fit flat-top and crown-top posts. A ball top has no place to mount one.') + '</p>');
      var h = '<div class="tcc-extras">', rec = recommendedCart(), posts = count();
      list.forEach(function (b) {
        var es = extraState(b), x = extraSel(b), p = b.product, v = chosen(p, x.sel);
        var priced = p.variants.filter(function (vv) { return vv.available && vv.options.every(function (o, oi) { return x.auto[oi] == null || o === x.auto[oi]; }); });
        var from = Math.min.apply(null, (priced.length ? priced : p.variants.filter(function (vv) { return vv.available; })).map(function (vv) { return vv.price; }));
        var img = (v && v.image) || p.image, matched = [], on = rec && rec.idx === b.idx;
        var hiddenOpt = {};
        String(b.hide || '').split(',').forEach(function (raw) { var want = raw.trim().toLowerCase(); if (want) hiddenOpt[want] = true; });
        p.options.forEach(function (o, oi) { if (hiddenOpt[o.toLowerCase()]) return; if (x.auto[oi] != null && valuesFor(p, oi, {}).length > 1) matched.push(x.auto[oi]); });
        var note = '';
        if (on && posts) note = b.capacity >= posts ? 'Recommended for ' + posts + (posts === 1 ? ' post' : ' posts') : 'Best fit for ' + posts + ' posts. Order more than one.';
        h += '<div class="tcc-extra' + (es.qty > 0 ? ' is-on' : '') + (on ? ' is-recommended' : '') + '" data-extra="' + b.idx + '">' +
          '<div class="tcc-extra__head">' + (img ? '<img src="' + esc(img) + '" alt="" width="160" height="160" loading="lazy">' : '') +
          '<span class="tcc-extra__txt"><strong>' + esc(b.label || p.title) + '</strong>' + (b.model ? '<small>' + esc(b.model) + '</small>' : '') +
          (note ? '<span class="tcc-extra__rec">' + esc(note) + '</span>' : '') +
          (matched.length ? '<small class="tcc-extra__match">' + esc(matched.join(' \u00b7 ')) + ' \u2013 matches your setup</small>' : '') + skuHTML(p, x.sel, 'tcc-extra__sku') + '</span>' +
          '<span class="tcc-extra__buy"><b>' + (v ? TCC.money(v.price) : esc(S.from) + ' ' + TCC.money(from)) + '</b>' + stepper(es.qty, 'xqty:' + b.idx, 0) + '</span></div>';
        if (es.qty > 0) h += optionsBlock(b, x.sel, 'xopt' + b.idx, -1, false, x.auto);
        h += '</div>';
      });
      return step(n, title, h + '</div>');
    }

    /* ----- render steps: type -> size -> product -> finish (-> rope / receiver) -> extras ----- */
    function render() {
      var box = el.querySelector('.tcc-builder');
      if (box) box.classList.toggle('tcc-builder--chosen', !!st);
      if (!st) { steps.innerHTML = ''; renderSummary(); return; }
      var sys = st.system, mains = of(sys, 'main'), h = '', n = 3;
      if (!mains.length) { steps.innerHTML = '<p class="tcc-lp__notice">' + esc(S.unconfigured) + '</p>'; renderSummary(); return; }
      h += sizeStep();
      h += step(n++, L[sys].main, productCards(mains, st.main, 'main'));
      var finishTitle = sys === 'rope' ? 'Finish' : 'Belt & finish';
      h += step(n++, finishTitle, st.main != null ? optionsBlock(blocks[st.main], st.mainSel, 'mainopt', beltIdx(), sys === 'belt') || '<p class="tcc-calc__hint">No options to choose.</p>' : '<p class="tcc-calc__hint tcc-step__wait">Choose your ' + (sys === 'wall' ? 'wall unit' : 'post') + ' first.</p>', st.main == null ? 'is-waiting' : '');
      if (sys === 'rope' || sys === 'wall') {
        var subs = of(sys, sys === 'rope' ? 'rope' : 'receiver');
        if (subs.length) {
          var body = productCards(subs, st.sub, 'sub', sys === 'wall');
          if (st.sub != null && st.sub > -1) body += optionsBlock(blocks[st.sub], st.subSel, 'subopt');
          h += step(n++, sys === 'rope' ? L.rope.rope : L.wall.receiver, body);
        }
      }
      h += extrasStep(n++);
      var active = document.activeElement, ak = active && active.dataset && el.contains(active) ? [active.dataset.key, active.dataset.value] : null;
      steps.innerHTML = h;
      if (ak && ak[0]) { var again = steps.querySelector('[data-key="' + ak[0] + '"][data-value="' + CSS.escape(ak[1] || '') + '"]'); if (again && !again.disabled) again.focus({ preventScroll: true }); }
      updateCalcOutputs();
      renderSummary();
    }

    function lines() {
      if (!st) return [];
      var out = [], sys = st.system, n = count();
      if (!n || st.main == null) return [];
      var mv = chosen(blocks[st.main].product, st.mainSel); if (!mv) return [];
      out.push({ block: blocks[st.main], v: mv, qty: n });
      if (sys === 'rope') { if (st.sub == null) return []; var rv = chosen(blocks[st.sub].product, st.subSel); if (!rv) return []; out.push({ block: blocks[st.sub], v: rv, qty: Math.max(1, n - 1) }); }
      if (sys === 'wall' && of('wall', 'receiver').length) { if (st.sub == null) return []; if (st.sub > -1) { var wv = chosen(blocks[st.sub].product, st.subSel); if (!wv) return []; out.push({ block: blocks[st.sub], v: wv, qty: n }); } }
      var extrasOk = true;
      of(sys, 'extra').forEach(function (b) {
        if (!extraShown(b)) return;
        var es = extraState(b); if (!es.qty) return;
        var v = chosen(b.product, extraSel(b).sel); if (!v) { extrasOk = false; return; }
        out.push({ block: b, v: v, qty: es.qty, extra: true });
      });
      return extrasOk ? out : [];
    }
    TCC._setupText = function () {
      return lines().map(function (l) { return l.qty + ' x ' + l.block.product.title + (l.v.title !== 'Default Title' ? ' (' + l.v.title + ')' : '') + (l.v.sku ? ' [SKU ' + l.v.sku + ']' : ''); }).join('\n');
    };
    function missing() {
      if (!st) return [];
      var m = [], sys = st.system;
      if (sys === 'belt') {
        if (!st.mode) m.push('size'); else if (st.mode === 'space' && !st.layout) m.push('shape'); else if (st.mode === 'space' && !calcPosts(calcState(), 11)) m.push(st.layout === 'u' && num(st.length) && !st.lanes ? 'number of lanes' : 'measurements'); else if (st.mode === 'count' && !st.count) m.push('post count');
      } else if (!st.count) m.push(sys === 'rope' ? 'number of posts' : 'number of units');
      if (st.main == null) m.push(sys === 'wall' ? 'wall unit' : 'post');
      else { var p = blocks[st.main].product; p.options.forEach(function (o, i) { if (st.mainSel[i] == null) m.push(o.toLowerCase()); }); }
      if (sys === 'rope') { if (st.sub == null) m.push('rope'); else blocks[st.sub].product.options.forEach(function (o, i) { if (st.subSel[i] == null) m.push('rope ' + o.toLowerCase().replace(/^rope /, '')); }); }
      if (sys === 'wall' && of('wall', 'receiver').length) { if (st.sub == null) m.push('receiver'); else if (st.sub > -1) blocks[st.sub].product.options.forEach(function (o, i) { if (st.subSel[i] == null) m.push('receiver ' + o.toLowerCase()); }); }
      of(sys, 'extra').forEach(function (b) { if (!extraShown(b)) return; var es = extraState(b); if (!es.qty) return; var sel = extraSel(b).sel; b.product.options.forEach(function (o, i) { if (sel[i] == null) m.push((b.label || 'extra').toLowerCase() + ' ' + o.toLowerCase()); }); });
      return m;
    }

    var visual = el.querySelector('[data-tcc-visual]');
    var mbar = el.querySelector('[data-tcc-mbar]');
    var inView = false, summaryVisible = false;
    function updateBar() {
      if (!mbar) return;
      var mobile = window.matchMedia('(max-width: 899px)').matches;
      mbar.hidden = !(mobile && inView && !summaryVisible && st);
      document.documentElement.classList.toggle('tcc-mobile-cart-active', !mbar.hidden);
    }
    if (mbar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { inView = en[0].isIntersecting; updateBar(); }).observe(el.querySelector('.tcc-builder'));
      new IntersectionObserver(function (en) { summaryVisible = en[0].isIntersecting && en[0].intersectionRatio >= 0.8; updateBar(); }, { threshold: 0.8, rootMargin: '0px 0px -112px 0px' }).observe(addBtn);
      window.addEventListener('resize', updateBar);
      mbar.querySelector('[data-tcc-mbar-add]').addEventListener('click', function () { addBtn.click(); });
    }
    /* Visualizer (v3 panel), two stacked visuals:
     * 1) the live diagram: side view for straight / post-count / rope / wall, top view for L and U, drawn from the calculated posts,
     *    in neutral grey until a finish / colour is picked;
     * 2) the real store photo of the chosen product: the variant image once a finish (or colour) is picked, the product's main image before. */
    /* Photo for a block (v6.3). Order:
     * 1) the variant's own image for everything chosen so far (rope colour + length + snap end, finish + belt, body + belt ...);
     * 2) no variant image: a product image whose alt text or file name names the chosen finish / colour;
     * 3) otherwise the product's main photo, with a "Shown in X, ordered in Y" note + swatches (the block setting
     *    "Main photo shows" says what the main photo depicts). Never another product's photo. */
    var FILE_CODES = { 'black': 'bk', 'polished stainless': 'ps', 'satin stainless': 'ss', 'polished brass': 'pb', 'satin brass': 'sb', 'yellow': 'yw', 'orange': 'or', 'red': 'rd' };
    var LOOK_RE = /finish|metal|colou?r/i;
    function nounFor(opt) { return /belt/i.test(opt) ? 'belt' : /body/i.test(opt) ? 'body' : /rope/i.test(opt) ? 'rope' : /snap/i.test(opt) ? 'snap end' : ''; }
    function parseShows(str) { var m = {}; String(str || '').split('|').forEach(function (pair) { var k = pair.split('='); if (k.length > 1) m[k[0].trim().toLowerCase()] = k.slice(1).join('=').trim(); }); return m; }
    function imgMatches(img, val) {
      var alt = String(img.alt || '').toLowerCase(), file = String(img.src || '').split('?')[0].split('/').pop().toLowerCase(), v = val.toLowerCase();
      var words = v.replace(/[^a-z0-9 ]+/g, ' ').split(/\s+/).filter(Boolean);
      if (alt && words.length && words.every(function (w) { return new RegExp('\\b' + w + '\\b').test(alt); })) return 0;
      var code = FILE_CODES[v], fileWords = file.replace(/[^a-z0-9]+/g, ' ');
      if (words.length && words.every(function (w) { return new RegExp('\\b' + w + '\\b').test(fileWords); })) return 1;
      if (code) { var mm = new RegExp('(^|[^a-z])' + code + '([^a-z]|$)').exec(file); if (mm) return 2 + mm.index / 1000; }
      return -1;
    }
    function swatchCss(opt, val) {
      if (/belt/i.test(opt)) {
        var b = beltSpec(val);
        if (b.kind === 'diagonal') return 'repeating-linear-gradient(45deg,' + b.base + ' 0 4px,' + b.alt + ' 4px 8px)';
        if (b.kind === 'stripe') return 'linear-gradient(' + b.base + ' 0 36%,' + b.alt + ' 36% 64%,' + b.base + ' 64%)';
        if (b.kind === 'text') return 'linear-gradient(' + b.base + ' 0 34%,' + b.ink + ' 34% 66%,' + b.base + ' 66%)';
        return b.base;
      }
      if (/rope/i.test(opt)) return colorHex(val);
      var f = finishStops(val); return 'linear-gradient(90deg,' + f[0] + ',' + f[1] + ' 45%,' + f[2] + ')';
    }
    function photoFor(block, sel) {
      var p = block.product, opts = p.options;
      var picked = opts.map(function (o, i) { return sel[i]; }).filter(function (v) { return v && v !== 'Default Title'; }).join(' / ');
      var out = { src: p.image, mode: 'product', label: block.label || p.title, picked: picked, note: '', swatches: [] };
      var look = [];
      opts.forEach(function (o, i) { if (sel[i] != null && sel[i] !== 'Default Title' && LOOK_RE.test(o) && !/snap/i.test(o)) look.push({ i: i, opt: o, val: sel[i] }); });
      if (opts.some(function (o, i) { return sel[i] != null; })) {
        var match = p.variants.filter(function (v) { return v.image && v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); });
        var best = match.filter(function (v) { return v.available; })[0] || match[0];
        if (best) { out.src = best.image; out.mode = 'variant'; return out; }
      }
      if (!look.length) return out;
      var imgs = p.images || [], shownBy = {}, depicted = null;
      /* the first looked-at option (finish / body / rope colour) decides the photo, the others only refine it */
      var primary = look[0];
      var cands = imgs.map(function (img) { return { img: img, r: imgMatches(img, primary.val) }; }).filter(function (c) { return c.r >= 0; });
      if (cands.length) {
        cands.forEach(function (c) { c.extra = look.slice(1).filter(function (l) { return imgMatches(c.img, l.val) >= 0; }).length; });
        cands.sort(function (x, y) { return (y.extra - x.extra) || (x.r - y.r); });
        out.src = cands[0].img.src; out.mode = 'image'; depicted = cands[0];
        shownBy[primary.opt] = primary.val;
        look.slice(1).forEach(function (l) { if (imgMatches(depicted.img, l.val) >= 0) shownBy[l.opt] = l.val; });
      }
      var shows = parseShows(block.shows), shown = [], ordered = [];
      look.forEach(function (l) {
        if (shownBy[l.opt]) return;
        var sv = out.mode === 'product' ? shows[l.opt.toLowerCase()] : '';
        if (sv && sv.toLowerCase() === l.val.toLowerCase()) return;
        ordered.push(l); shown.push(sv ? { l: l, v: sv } : null);
      });
      if (ordered.length) {
        var sh = shown.filter(Boolean);
        var nm = function (l, v) { var w = nounFor(l.opt); return v + (w ? ' ' + w : ''); };
        out.note = (sh.length === ordered.length ? 'Shown in ' + sh.map(function (x) { return nm(x.l, x.v); }).join(', ') + ' \u00b7 ordered in ' :
          'Photo shows a different ' + ordered.map(function (l) { var w = nounFor(l.opt); return /colou?r/i.test(l.opt) ? (w ? w + ' ' : '') + 'color' : 'finish'; }).join(' / ') + ' \u00b7 ordered in ') +
          ordered.map(function (l) { return sh.length === ordered.length ? nm(l, l.val) : l.val; }).join(', ');
        out.swatches = ordered.map(function (l) { return { label: l.val, css: swatchCss(l.opt, l.val) }; });
      }
      return out;
    }
    function renderVisual() {
      if (!visual) return;
      var art = visual.querySelector('[data-tcc-visual-art]'), photos = visual.querySelector('[data-tcc-visual-photos]');
      if (!st) {   /* empty state before a barrier type is picked */
        art.innerHTML = renderSetupSVG({ sys: 'belt', n: 4, finish: '', color: '', badge: 'Your setup preview' });
        art.hidden = false; art.dataset.state = 'empty'; art.dataset.finish = 'neutral';
        if (photos) { photos.innerHTML = ''; photos.hidden = true; }
        visual.hidden = false; return;
      }
      var sys = st.system, main = st.main != null ? blocks[st.main] : null, sub = st.sub != null && st.sub > -1 ? blocks[st.sub] : null, n = count(), plan = null, badge = '';
      var finish = main ? optVal(main.product, st.mainSel, /finish|post colou?r|body colou?r|metal/i) : '';
      var color = sys === 'rope' ? (sub ? optVal(sub.product, st.subSel, /colou?r/i) : '') : (main ? optVal(main.product, st.mainSel, /belt colou?r|^colou?r/i) : '');
      if (sys === 'belt' && st.mode === 'space' && st.layout) {
        var bv = beltValue(), r = calcFor(bv || BELT_LENGTHS[0]);
        if (r) {
          plan = r.geo; n = st.count != null && bv ? st.count : r.posts;
          badge = n + ' posts' + (bv ? '' : ' with ' + BELT_LENGTHS[0] + ' ft belts');
          if (st.count != null && st.count !== r.posts && bv) badge += ' (drawing: ' + r.posts + ')';
        }
      }
      var list = [];
      if (main) list.push(photoFor(main, st.mainSel));
      if (sub) list.push(photoFor(sub, st.subSel));
      /* The diagram is ALWAYS drawn (v6.2 fix: it used to be emptied/hidden until a count or valid measurements existed).
       * real = calculated layout / chosen count; placeholder = typical layout in neutral grey; empty = nothing chosen yet. */
      var state = 'real', ropeKind = sys === 'rope' && sub && /braid/i.test(sub.product.title + ' ' + (sub.label || '')) ? 'braided' : 'velour';
      /* chosen finish and belt / rope colour are used in every state (v6.3); only what is not chosen yet stays neutral grey */
      if (plan && plan.layout !== 'straight') {
        art.innerHTML = planArt(plan, finish, color, badge, badge + ', top view');
      } else if (n) {
        art.innerHTML = renderSetupSVG({ sys: sys, n: n, finish: finish, color: color, ropeKind: ropeKind, receiver: sys === 'wall' ? (st.sub == null ? null : !!sub) : false, badge: badge });
      } else if (sys === 'belt' && st.mode === 'space' && st.layout) {
        state = 'placeholder';
        if (st.layout === 'straight') art.innerHTML = renderSetupSVG({ sys: 'belt', n: 4, finish: finish, color: color, badge: 'Enter your measurements' });
        else {
          var smp = SHAPE_SAMPLES[st.layout], pc = {}; for (var k in smp.c) pc[k] = smp.c[k];
          if (st.layout === 'u' && st.lanes) pc.lanes = st.lanes;
          var sampleLabel = st.layout === 'l' ? 'Example: 20 ft + 15 ft' : 'Enter your measurements';
          art.innerHTML = planArt(shapeGeometry(pc, smp.s), finish, color, sampleLabel, sampleLabel + ', top view');
        }
      } else {
        state = sys === 'belt' && !st.mode ? 'empty' : 'placeholder';
        var lbl = sys === 'wall' ? 'Choose how many units' : sys === 'rope' || st.mode === 'count' ? 'Choose how many posts' : st.mode === 'space' ? 'Choose a shape' : 'Your setup preview';
        art.innerHTML = renderSetupSVG({ sys: sys, n: sys === 'wall' ? 1 : 4, finish: finish, color: color, ropeKind: ropeKind, receiver: sys === 'wall' ? null : false, badge: lbl });
      }
      art.hidden = false;
      art.dataset.state = state;
      art.dataset.finish = finish ? 'chosen' : 'neutral';
      if (photos) {
        photos.innerHTML = list.map(function (ph) {
          return '<figure class="tcc-photo" data-tcc-photo="' + ph.mode + '">' + (ph.src ? '<img src="' + esc(ph.src) + '" alt="' + esc(ph.label + (ph.picked ? ', ' + ph.picked : '')) + '" width="640" height="480" loading="lazy">' : '') +
            '<figcaption><strong>' + esc(ph.label) + '</strong>' + (ph.picked ? '<span>' + esc(ph.picked) + '</span>' : '') +
            (ph.note ? '<span class="tcc-photo__note" data-tcc-photo-note>' + ph.swatches.map(function (w) { return '<i class="tcc-swatch" style="background:' + w.css + '" title="' + esc(w.label) + '"></i>'; }).join('') + '<span>' + esc(ph.note) + '</span></span>' : '') +
            '</figcaption></figure>';
        }).join('');
        photos.hidden = !list.length;
        photos.classList.toggle('tcc-visual__photos--two', list.length > 1);
      }
      visual.hidden = false;
    }
    function recoHTML() {
      if (!st || st.system !== 'belt' || st.mode !== 'space') return '';
      var r = calcFor(beltValue()); if (!r) return '';
      var n = count(), h = '<div class="tcc-reco" data-tcc-reco><div class="tcc-reco__row"><strong class="tcc-reco__count" data-tcc-reco-posts>' + n + ' posts</strong>' + stepper(n) + '</div>' +
        '<p class="tcc-reco__facts">' + (r.lanes ? r.lanes + ' lanes, ~' + Math.round(r.laneWidth * 12) + ' in wide \u00b7 ' : '') + 'about ' + ft(r.coverage) + ' of queue</p>';
      if (st.count != null && st.count !== r.posts) h += '<p class="tcc-reco__note">Calculated: ' + r.posts + '. <button type="button" class="tcc-linkbtn" data-key="auto" data-value="1">Use ' + r.posts + '</button></p>';
      if (r.notes.indexOf('narrow') > -1) h += '<p class="tcc-reco__warn">Lanes are under 36 in. Use fewer lanes or a wider area.</p>';
      if (!r.confirmed && (cfg.designMode || window.TCC_PREVIEW)) h += '<p class="tcc-lp__notice">Spacing placeholder: full belt length (' + ft(spacingFor(beltValue()).s) + ').</p>';
      return h + '</div>';
    }
    function renderSummary() {
      renderVisual();
      if (st && st.main != null) queueRemote(blocks[st.main].product, st.mainSel);
      if (st && st.sub != null && st.sub > -1) queueRemote(blocks[st.sub].product, st.subSel);
      var ls = lines(), total = 0, ok = ls.length > 0, n = st ? count() : null;
      var html = recoHTML();
      if (ls.length) {
        html += '<ul class="tcc-summary__lines">' + ls.map(function (l) {
          total += l.v.price * l.qty; if (!l.v.available) ok = false;
          var vt = l.v.title === 'Default Title' ? '' : '<span class="tcc-summary__variant">' + esc(l.v.title) + '</span>';
          return '<li><span>' + l.qty + ' \u00d7 ' + esc(l.block.label || l.block.product.title) + vt + (l.v.sku ? '<span class="tcc-summary__sku" data-tcc-sku="' + esc(l.v.sku) + '">SKU: ' + esc(l.v.sku) + '</span>' : '') + (l.v.available ? '' : ' <em>(' + esc(S.soldOut) + ')</em>') + '</span><span>' + TCC.money(l.v.price * l.qty) + '</span></li>';
        }).join('') + '</ul>';
      } else if (st) {
        var m = missing();
        var look = '';
        if (!m.length && st.main != null && complete(blocks[st.main].product, st.mainSel) && !chosen(blocks[st.main].product, st.mainSel)) {
          look = remoteLookup[remoteKey(blocks[st.main].product, st.mainSel)] || 'pending';
        }
        if (look === 'pending') html += '<p class="tcc-summary__empty">Checking that combination\u2026</p>';
        else if (look === 'miss') html += '<p class="tcc-summary__empty">That combination isn\u2019t available. Choose another length, finish or color.</p>';
        else html += '<p class="tcc-summary__empty">Still to choose: ' + esc(m.join(', ')) + '.</p>';
      } else html += '<p class="tcc-summary__empty">' + esc(S.empty) + '</p>';
      summary.innerHTML = html;
      totalEl.textContent = ls.length ? TCC.money(total) : '\u2014';
      var adding = addBtn.getAttribute('aria-busy') === 'true';
      addBtn.disabled = !ok || adding; if (buyBtn) buyBtn.disabled = !ok || adding;
      if (mbar) {
        mbar.querySelector('[data-tcc-mbar-total]').textContent = totalEl.textContent;
        mbar.querySelector('[data-tcc-mbar-add]').disabled = !ok || adding;
        var art = visual && visual.querySelector('[data-tcc-visual-art]');
        mbar.querySelector('[data-tcc-mbar-art]').innerHTML = art && !visual.hidden ? art.innerHTML.replace(/id="(tcc[gp][^"]+)"/g, 'id="m$1"').replace(/url\(#(tcc[gp][^)]+)\)/g, 'url(#m$1)') : '';
        updateBar();
      }
      requestAnimationFrame(revealCartActions);
    }

    function selectSystem(sys, preset) {
      var btn = el.querySelector('[data-tcc-system="' + sys + '"]');
      if (!btn) return false;
      if (!started) { started = true; TCC.track('builder_started', {}); }
      el.querySelectorAll('[data-tcc-system]').forEach(function (b) { var on = b === btn; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on); });
      TCC.track('builder_select_system', { system: sys, preset: preset ? preset.name : undefined });
      reset(sys);
      /* Only shortcuts that imply one thing preselect that one thing: a layout (#small-queue, #multi-lane-queue) or a post count (#4-posts) */
      if (preset && sys === 'belt') {
        if (preset.layout && LAYOUTS.indexOf(preset.layout) > -1) { st.mode = 'space'; st.layout = preset.layout; }
        if (preset.posts && +preset.posts > 0) { st.mode = 'count'; st.count = +preset.posts; }
      }
      render();
      return true;
    }
    el.__tccOpen = selectSystem;

    function setCount(v) { st.count = v; TCC.track('builder_select_quantity', { system: st.system, quantity: v }); }
    el.addEventListener('click', function (e) {
      var sysBtn = e.target.closest('[data-tcc-system]');
      if (sysBtn) { selectSystem(sysBtn.dataset.tccSystem); return; }
      var more = e.target.closest('[data-more]');
      if (more) { expanded[more.dataset.more] = true; render(); return; }
      var b = e.target.closest('[data-key]');
      if (!b || b.disabled || !st) return;
      var key = b.dataset.key, val = b.dataset.value;
      if (key === 'adj') { var base = count() || 1; setCount(Math.max(1, base + (+val))); render(); return; }
      if (key === 'auto') { st.count = null; render(); return; }
      if (!steps.contains(b)) return;
      if (key === 'mode') { if (st.mode !== val) { st.mode = val; st.count = null; } TCC.track('calc_mode', { value: val }); }
      else if (key === 'layout') { if (st.layout !== val) { st.layout = val; st.lanes = null; st.count = null; } TCC.track('calc_layout', { value: val }); }
      else if (key === 'lanes') { st.lanes = st.layout !== 'u' && st.lanes === +val ? null : +val; st.count = null; TCC.track('calc_lanes', { value: val }); }
      else if (key === 'count') { setCount(+val); if (st.system === 'belt') TCC.track('calc_quick_pick', { posts: +val }); }
      else if (key === 'main') { if (st.main !== +val) { st.main = +val; st.mainSel = fix(blocks[+val].product, {}); } TCC.track('builder_select_product', { system: st.system, product: blocks[+val].product.title }); }
      else if (key === 'sub') { if (st.sub !== +val) { st.sub = +val; st.subSel = +val > -1 ? fix(blocks[+val].product, {}) : {}; } TCC.track('builder_select_product', { system: st.system, role: st.system === 'rope' ? 'rope' : 'receiver', product: +val > -1 ? blocks[+val].product.title : 'none' }); }
      else if (/^xqty:/.test(key)) {
        var xb = blocks[+key.split(':')[1]], es = extraState(xb), was = es.qty;
        es.qty = Math.max(0, es.qty + (+val));
        if (!was && es.qty) TCC.track('builder_add_accessory', { system: st.system, product: xb.product.title });
      }
      else if (/^xopt\d+:/.test(key)) {
        var xp = key.split(':'), xbl = blocks[+xp[0].slice(4)], xs = extraState(xbl), xx = extraSel(xbl), sel2 = xx.sel;
        sel2[+xp[1]] = val; fix(xbl.product, sel2); xs.sel = {};
        Object.keys(sel2).forEach(function (k) { if (xx.auto[k] == null && sel2[k] != null) xs.sel[k] = sel2[k]; });  /* auto-matched values are never stored, so they follow the post finish */
        TCC.track(optEvent(xbl.product.options[+xp[1]]), { system: st.system, option: xbl.product.options[+xp[1]], value: val, extra: xbl.product.title });
      }
      else {
        var parts = key.split(':'), oi = +parts[1];
        var idx = parts[0] === 'mainopt' ? st.main : parts[0] === 'subopt' ? st.sub : null;
        if (idx == null) return;
        var prd = blocks[idx].product, sel = parts[0] === 'mainopt' ? st.mainSel : st.subSel;
        sel[oi] = val; fix(prd, sel);
        if (parts[0] === 'mainopt' && oi === beltIdx() && st.system === 'belt' && st.mode === 'space') st.count = null;
        TCC.track(optEvent(prd.options[oi]), { system: st.system, option: prd.options[oi], value: val });
      }
      render();
    });
    el.addEventListener('change', function (e) {
      var f = e.target.closest && e.target.closest('[data-calc]');
      if (f) TCC.track('calc_dimension', { field: f.dataset.calc, value: f.value });
    });
    el.addEventListener('input', function (e) {
      var f = e.target.closest && e.target.closest('[data-calc]');
      if (!f || !st) return;
      var name = f.dataset.calc;
      if (/^run\d$/.test(name)) st.runs[+name.slice(3)] = f.value; else st[name] = f.value;
      st.count = null;
      updateCalcOutputs(); renderSummary();
    });

    el.addEventListener('tcc:cart-idle', renderSummary);
    function builderItems(ls, label) { return ls.map(function (l) { return { id: l.v.id, quantity: l.qty, _price: l.v.price, _name: l.block.product.title, _variant: l.v.title, _sku: l.v.sku, properties: { _tcc_setup: label } }; }); }
    addBtn.addEventListener('click', function () {
      var ls = lines(); if (!ls.length) return;
      var label = L[st.system].name;
      TCC.track('builder_completed', { system: st.system, quantity: count(), total_lines: ls.length, layout: st.layout || undefined });
      doAdd(addBtn, status, builderItems(ls, label), { setup: label, source: 'build_your_own' }, { added: S.added, viewCart: S.viewCart, checkout: S.checkout, error: S.error });
    });
    if (buyBtn) buyBtn.addEventListener('click', function () {
      var ls = lines(); if (!ls.length || buyBtn.disabled) return;
      var label = L[st.system].name;
      TCC.track('builder_completed', { system: st.system, total_lines: ls.length, method: 'buy_now' });
      TCC.buyNow(builderItems(ls, label), { setup: label, source: 'build_your_own' }, status);
    });
    el.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('[data-tcc-quote-from-builder]'); if (a) { TCC._quoteSetup = TCC._setupText(); document.dispatchEvent(new CustomEvent('tcc:quote-prefill')); } });
    render();
  }

  /* ---------- ad routing: #build, #belt-queue, #rope-line, #wall-mounted and preset shortcuts ---------- */
  function routes() {
    var map = {};
    document.querySelectorAll('[data-tcc-builder]').forEach(function (b) {
      var cfg; try { cfg = JSON.parse(b.querySelector('[data-tcc-builder-config]').textContent); } catch (e) { return; }
      map[b.id] = { builder: b };
      var a = cfg.anchors || {};
      ['belt', 'rope', 'wall'].forEach(function (s) { if (a[s]) map[a[s]] = { builder: b, system: s }; });
      (cfg.presets || []).forEach(function (p) { if (p.anchor) map[p.anchor] = { builder: b, system: p.system, preset: p }; });
      /* #2-posts, #4-posts, #6-posts, #10-posts: open the belt calculator with that post count (manual override) */
      ((cfg.calc && cfg.calc.quickPicks) || []).forEach(function (q) { var k = q + '-posts'; if (!map[k]) map[k] = { builder: b, system: 'belt', preset: { name: k, posts: q } }; });
    });
    document.querySelectorAll('[data-tcc-open]').forEach(function (l) {
      var id = (l.getAttribute('href') || '').replace(/^#/, '');
      if (!id || map[id] && map[id].system) return;
      var b = document.querySelector('[data-tcc-builder]'); if (!b) return;
      map[id] = { builder: b, system: l.dataset.tccOpen, preset: { name: id, layout: l.dataset.tccLayout, lanes: l.dataset.tccLanes, mode: l.dataset.tccMode, posts: l.dataset.tccPosts } };
    });
    return map;
  }
  function settle(target, smooth) {
    /* scroll, then correct once late content (lazy images, re-rendered steps) has moved the target */
    var margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    var fix = function () { if (Math.abs(target.getBoundingClientRect().top - margin) > 4) target.scrollIntoView({ behavior: 'auto', block: 'start' }); };
    setTimeout(fix, smooth ? 900 : 350);
    if (!smooth && document.readyState !== 'complete') window.addEventListener('load', function () { setTimeout(fix, 50); }, { once: true });
  }
  function openRoute(id, smooth) {
    var r = routes()[id];
    if (!r) { var t = id && document.getElementById(id); if (t && t.closest('.tcc-lp')) { settle(t, smooth); return true; } return false; }
    if (r.system && r.builder.__tccOpen) r.builder.__tccOpen(r.system, r.preset || { name: id });
    settle(r.builder, smooth);
    TCC.track('route_open', { anchor: id, system: r.system || 'none' });
    return true;
  }
  TCC.openRoute = openRoute;
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey) return;
    var id = a.getAttribute('href').slice(1);
    if (!routes()[id]) return;
    e.preventDefault();
    if (location.hash !== '#' + id) history.pushState(null, '', '#' + id);
    openRoute(id, true);
  });
  window.addEventListener('hashchange', function () { openRoute(location.hash.slice(1), true); });

  /* ---------- quote form: generate_lead on submit, prefilled with the current setup ---------- */
  function initQuote(form) {
    if (form.__tcc) return; form.__tcc = true;
    var wrap = form.closest('[data-tcc-quote]') || form;
    var setupField = form.querySelector('[data-tcc-quote-setup]');
    var setupNote = form.querySelector('[data-tcc-quote-setup-note]');
    var prefill = function () {
      if (!setupField) return;
      var t = (TCC._setupText && TCC._setupText()) || TCC._quoteSetup || '';
      setupField.value = t;
      if (setupNote) { setupNote.hidden = !t; setupNote.textContent = t ? 'Your setup from the builder is included: ' + t.split('\n').map(function (l) { return l.replace(/ \[SKU[^\]]*\]/, '').replace(/ \(.*\)$/, ''); }).join('; ') + '.' : ''; }
    };
    form.addEventListener('focusin', prefill);
    document.addEventListener('tcc:quote-prefill', prefill);
    document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href="#quote"]'); if (a) prefill(); });
    /* Lead conversion = Shopify confirmed the contact form (?contact_posted=true), not the click/submit.
     * On submit (valid fields) we only store a one-time "pending" flag in sessionStorage. The success page load
     * consumes it and fires generate_lead (GA4) + the Ads LP Quote Request conversion exactly once; a reload of
     * the success URL has no flag, so it does not fire again. Survives the POST redirect and Shopify's spam challenge. */
    var PENDING = 'tcc_quote_pending';
    var sendTo = wrap.getAttribute('data-tcc-ads-send-to') || '';
    function fireLead(info) {
      if (TCC._leadFired) return; TCC._leadFired = true;
      TCC.track('generate_lead', { lead_source: 'quote_form', form_id: form.id || 'tcc-quote', locations: info.locations, has_setup: !!info.has_setup });
      if (!sendTo) return;
      var params = { send_to: sendTo };
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', params);
      } else {
        /* No on-page gtag (Google tag runs in the Shopify app pixel). Queue it gtag-style so a Google tag reading
         * this dataLayer processes it once, and expose a named event for GTM. One branch only, never both. */
        window.dataLayer = window.dataLayer || [];
        (function () { window.dataLayer.push(arguments); })('event', 'conversion', params);
        window.dataLayer.push({ event: 'ads_conversion_lp_quote', send_to: sendTo, tcc_source: 'tcc_landing' });
      }
      document.dispatchEvent(new CustomEvent('tcc:lead-conversion', { detail: { send_to: sendTo, via: typeof window.gtag === 'function' ? 'gtag' : 'dataLayer' } }));
    }
    function consumePending() {
      var raw = null;
      try { raw = sessionStorage.getItem(PENDING); sessionStorage.removeItem(PENDING); } catch (e) {}
      if (!raw) return;
      var info = {}; try { info = JSON.parse(raw) || {}; } catch (e) {}
      if (info.t && Date.now() - info.t > 2 * 60 * 60 * 1000) return; /* stale flag (older than 2 h) */
      /* wait for window load so an async Google tag can define gtag first */
      if (document.readyState === 'complete') fireLead(info); else window.addEventListener('load', function () { fireLead(info); }, { once: true });
    }
    form.addEventListener('submit', function (e) {
      if (form.checkValidity && !form.checkValidity()) return;
      prefill();
      var loc = form.querySelector('[name="contact[Locations]"]');
      var info = { t: Date.now(), locations: loc ? loc.value : undefined, has_setup: !!(setupField && setupField.value.trim()) };
      try { sessionStorage.setItem(PENDING, JSON.stringify(info)); } catch (err) {}
      TCC.track('quote_form_submit', { form_id: form.id || 'tcc-quote' });
      if (window.TCC_PREVIEW) {
        /* static preview has no /contact endpoint: simulate Shopify's success state */
        e.preventDefault();
        var ok = wrap.querySelector('[data-tcc-quote-thanks]'); if (ok) { ok.hidden = false; ok.insertAdjacentHTML('afterbegin', '<p class="tcc-lp__notice">Preview: the form was not sent (static page).</p>'); }
        form.hidden = true;
        consumePending();
      }
    });
    if (/[?&]contact_posted=true/.test(location.search)) consumePending();
    var attrField = form.querySelector('[data-tcc-quote-attr]');
    if (attrField) { var at = TCC.attribution(), parts = []; for (var ak in at) parts.push(ak + '=' + at[ak]); attrField.value = parts.join('; ') || 'none'; }
    if (/[?&]contact_posted=true/.test(location.search)) { var qa = document.getElementById('quote'); if (qa) setTimeout(function () { qa.scrollIntoView(); }, 50); }
    if (/[?&]contact_posted=true/.test(location.search) && !form.querySelector('[data-tcc-quote-thanks]')) { var t = wrap.querySelector('[data-tcc-quote-thanks]'); if (t) { t.hidden = false; form.hidden = true; } }
  }

  /* Sit the setup card just under whatever header is actually stuck to the top of the page. */
  function measureCartTop() {
    var bottom = 0;
    document.querySelectorAll('header, #header, .\\#header, #mainHeader, [id^="mainHeader"], [id^="shopify-section-header"], .shopify-section-group-header-group').forEach(function (node) {
      var style = window.getComputedStyle(node);
      if (style.position !== 'fixed' && style.position !== 'sticky') return;
      var rect = node.getBoundingClientRect();
      if (rect.height > 0 && rect.top <= 2 && rect.bottom > bottom) bottom = rect.bottom;
    });
    var declared = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    if (declared > bottom) bottom = declared;
    if (bottom > 0) document.documentElement.style.setProperty('--tcc-cart-top', Math.ceil(bottom) + 'px');
  }
  /* At the end of Build your setup, scroll the sticky cart so Add to cart and Buy now are in view. */
  function revealCartActions() {
    if (!window.matchMedia('(min-width: 900px)').matches) return;
    document.querySelectorAll('[data-tcc-builder]').forEach(function (builder) {
      var summary = builder.querySelector('.tcc-builder__summary');
      var anchor = builder.querySelector('[data-tcc-builder-buy]') || builder.querySelector('[data-tcc-builder-add]');
      if (!summary || !anchor || summary.scrollHeight <= summary.clientHeight + 8) {
        if (summary) delete summary.dataset.tccActions;
        return;
      }
      var bottom = builder.getBoundingClientRect().bottom;
      var atEnd = bottom <= window.innerHeight + 64 && bottom > window.innerHeight * 0.4;
      if (!atEnd) {
        if (summary.dataset.tccActions === 'end') {
          delete summary.dataset.tccActions;
          summary.scrollTo({ top: 0, behavior: 'smooth' });
        }
        return;
      }
      var hidden = anchor.getBoundingClientRect().bottom - summary.getBoundingClientRect().bottom;
      if (hidden <= 8 || summary.dataset.tccActions === 'end') return;
      summary.dataset.tccActions = 'end';
      summary.scrollTo({ top: summary.scrollTop + hidden + 16, behavior: 'smooth' });
      setTimeout(function () {
        if (!summary.isConnected) return;
        var still = anchor.getBoundingClientRect().bottom - summary.getBoundingClientRect().bottom;
        if (still > 24) delete summary.dataset.tccActions;
      }, 480);
    });
  }
  measureCartTop();
  window.addEventListener('resize', function () { measureCartTop(); revealCartActions(); });
  window.addEventListener('load', measureCartTop);
  window.addEventListener('scroll', revealCartActions, { passive: true });

  function init(scope) {
    scope = scope || document;
    measureCartTop();
    scope.querySelectorAll('[data-tcc-ready-card]').forEach(initReady);
    scope.querySelectorAll('[data-tcc-builder]').forEach(initBuilder);
    scope.querySelectorAll('form[data-tcc-quote-form]').forEach(initQuote);
    if (!TCC._viewSent && document.querySelector('[data-tcc-page-view="true"]')) { TCC._viewSent = true; TCC.track('landing_page_view', { path: location.pathname, anchor: location.hash.slice(1) || undefined, headline_key: window.TCCHeadlineKey || 'default' }); }
    if (!TCC._routed && location.hash.length > 1) { TCC._routed = true; openRoute(decodeURIComponent(location.hash.slice(1)), false); }
  }
  TCC.init = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
